<app-loader *ngIf="isLoading"></app-loader>
<div id="qh-reports">
  <div class="row mb-lg-0 mb-4 ">
    <div class="col-lg-5 col-md-4 pt-2 mb-3 mb-md-0  d-md-block d-none  ">
      <div class="d-lg-flex gap-2 align-items-center">
        <div>
          <app-main-heading>
            <span title i18n-title>{{ "SIDEBAR.INSIGHTS" | translate }}</span>
          </app-main-heading>

        </div>
      </div>
    </div>

    <div class="col-lg-7 col-md-8 mb-3 d-md-block d-none">
      <div class="flex flex-wrap align-items-center justify-content-end">
        <div class="d-flex justify-content-between my-1">
          <div class="me-0 me-lg-0 d-flex order order-1 w-100 order-lg-3 cursor-pointer"
            *ngIf="this.currentUserData.roleType != 'MEMBERS'">
            <ng-select #reportUserSelect class="bg-transparent custom w-100" [items]=" userResponse" [(ngModel)]="user"
              bindLabel="name" bindValue="id" [clearable]=false [searchable]=false
              (ngModelChange)="getUserDevices($event)">
              <ng-template class="text-truncate custom" ng-label-tmp let-item="item">
                <img height="15" width="15" src="assets/images/Vector 651usericon.svg" />
                <span class="ps-2">{{ item?.name?.length > 15 ? item?.name?.slice(0,15) + "..." : item?.name }}</span>
              </ng-template>
              <ng-template class="text-truncate custom" ng-option-tmp let-item="item" let-index="index">
                <span title={{item?.name}}>{{ item?.name?.length> 15 ? item.name.slice(0,15) + "..." :
                  item?.name}}</span>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </div>
    <!-- Top side design for screen 414 * 768  -->
    <div class="container-fluid gap-2 d-md-none d-block d-flex justify-content-between  align-items-center">
      <div>
        <app-main-heading>
          <span title i18n-title>{{ "SIDEBAR.INSIGHTS" | translate }}</span>
        </app-main-heading>
      </div>
    </div>

    <div class="container-fluid gap-2 d-md-none d-block  py-3 " id="reportUserDev">

      <div class="row justify-content-between">
        <div class="col-sm-5 col-6 cursor-pointer" i18n-title>
          <ng-select #mobileViewDevices class="bg-transparent custom w-100" [items]=" userResponse" [(ngModel)]="user"
            bindLabel="name" bindValue="id" [clearable]=false [searchable]=false
            (ngModelChange)="getUserDevices($event)">
            <ng-template class="text-truncate custom" ng-label-tmp let-item="item">
              <img height="15" width="15" src="assets/images/Vector 651usericon.svg" />
              <span class="ps-2">{{ item?.name?.length > 15 ? item?.name?.slice(0,15) + "..." : item?.name }}</span>
            </ng-template>
            <ng-template class="text-truncate custom" ng-option-tmp let-item="item" let-index="index">
              <span title={{item?.name}}>{{ item?.name?.length> 15 ? item.name.slice(0,15) + "..." :
                item?.name}}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>

    </div>
    <div class="bg-white text-center rounded-25 relative" *ngIf="devicesList?.length === 0" i18n-title>
      <div class="col-sm-12 text-center">
        <div class="mt-5">
          <span><img src="./assets/images/screenEmptyReport.svg" alt="" width="25%"></span>
        </div>
        <div class="mt-5 mb-5">
          <span class="empty-report-text">{{ "REPORTS.NODEVICESASSIGNED" | translate }}</span>
        </div>
      </div>
    </div>

    <div class="container-fluid" *ngIf="devicesList?.length != 0">
      <div class="d-flex justify-content-between nav-tabs pt-1">
        <div>
          <div class="mt-0"><button class="" [ngClass]="isScreentimeMonitoring ? 'buttonsClickfocus' : 'buttonsClick'"
              (click)="openTabs('SCREEN')">{{
              "SETTINGS.SCREENTIME" |
              translate
              }}</button>
            <button *ngIf="showParentalTab" type="menu" class="ms-2"
              [ngClass]="isParentalControls ? 'buttonsClickfocus' : 'buttonsClick'" (click)="openTabs('PARENTAL')">{{
              "SETTINGS.PARENTALCONTROL" |
              translate
              }} </button>
            <button type="menu" class="ms-2" [ngClass]="isThreatReport ? 'buttonsClickfocus' : 'buttonsClick'"
              (click)="openTabs('THREAT')">{{
              "PARENTALREPORTS.THREATS" |
              translate
              }}</button>
            <button type="menu" *ngIf="showParentalTab" class="ms-2"
              [ngClass]="isYoutubeReports ? 'buttonsClickfocus' : 'buttonsClick'" (click)="openTabs('YOUTUBE')">{{
              "SETTINGS.YOUTUBESUPERVISION" |
              translate
              }}</button>
            <button type="menu" class="ms-2" *ngIf="showDesktopReports"
              [ngClass]="isAntiTrackerReport ? 'buttonsClickfocus' : 'buttonsClick'"
              (click)="openTabs('ANTITRACKER')">{{ "DASHBOARD.ANTITRACKER" |
              translate
              }}</button>
            <button type="menu" class="ms-2" *ngIf="showDesktopReports"
              [ngClass]="isFirewallReport ? 'buttonsClickfocus' : 'buttonsClick'" (click)="openTabs('FIREWALL')">{{
              "DASHBOARD.FIREWALLPROTECTION" |
              translate
              }}</button>
            <button type="menu" class="ms-2" *ngIf="showDesktopReports"
              [ngClass]="isIdsIpsReport ? 'buttonsClickfocus' : 'buttonsClick'" (click)="openTabs('IDSIPS')">{{
              "DASHBOARD.IDSIPS" |
              translate
              }}</button>
          </div>
        </div>
      </div>
      <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      <ng-container *ngIf="isParentalControls">
        <div class="col-sm-12 mb-5 p-lg-0 p-sm-0 p-1 relative">
          <div class="mb-3 mt-0 p-0 barchartDiv">
            <ng-container *ngIf="parentalDeviceReport && !parentalGraph">
              <!-- Smart Paretal report will come here -->
              <div class="mt-3 bg-white p-3" style="border-radius: 12px;">
                <div class="col-sm-12 relative">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 text_20_600 ">
                      <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                            src="./assets/images/hitIcon.svg" alt=""></span>{{ "PARENTALREPORTS.ATTEMPTSTORESTRICTED" |
                        translate
                        }}</span>
                    </div>
                    <div class="mt-1 mb-3 ms-4 text_20_600 ">
                      <span> {{ totalHitCounts }} </span>
                      <span>{{ "PARENTALREPORTS.ATTEMPTS" | translate }}<span class="ms-1"
                          style="font-weight: 400;font-size: 12px;">{{
                          "DASHBOARD.INLAST7DAYS" | translate }}</span> </span>
                    </div>
                  </div>
                  <div class="relative">
                    <div style="position: absolute;top: 12px; right: 32px;">
                      <span class="me-1"><img class="me-1" src="./assets/images/webRedIcon.svg" alt="">{{
                        "PARENTALREPORTS.WEBSITE" | translate }} </span>
                      <span><img class="me-1" src="./assets/images/yellowRectIcon.svg" alt="">{{ "PARENTALREPORTS.APP" |
                        translate}}</span>
                    </div>
                  </div>
                  <div class="chart-container mt-5">
                    <canvas id="deviceWiseParental" width="400" height="200"></canvas>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="paretalToggle && parentalGraph">
              <!-- Smart Paretal report  Empty State -->
              <div class="mt-2 bg-white p-3" style="border-radius: 12px;">
                <div class="col-sm-12 relative">
                  <div class="border-bottom negative_padding ">
                    <div class=" mt-2 ms-4 text_20_600 mb-5 ">
                      <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                            src="./assets/images/hitIcon.svg" alt=""></span>{{ "PARENTALREPORTS.ATTEMPTSTORESTRICTED" |
                        translate
                        }}</span>
                    </div>
                  </div>
                  <div class="mt-5">
                    <div class="mb-3 text-center">
                      <div class="mt-4">
                        <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                      </div>
                      <div class="mt-3 mb-4 pb-1">
                        <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!paretalToggle && parentalGraph">
              <!-- Smart Paretal report  Toggle State -->
              <div class="mt-2 bg-white p-3" style="border-radius: 12px;">
                <div class="col-sm-12 relative">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 text_20_600 mb-5 ">
                      <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                            src="./assets/images/hitIcon.svg" alt=""></span>{{ "PARENTALREPORTS.ATTEMPTSTORESTRICTED" |
                        translate
                        }}</span>
                    </div>
                  </div>
                  <div class="mt-5">
                    <div class="mb-3 text-center">
                      <div class="mt-2">
                        <span><img src="./assets/images/enableToggle.svg" alt=""></span>
                      </div>
                      <div class="mt-3 mb-0 pb-1">
                        <span class="empty-report-text">{{ "DASHBOARD.ENABLEPARENTALSETTINGS" | translate }}</span>
                      </div>
                      <div class="mb-1">
                        <span> {{ "DASHBOARD.ENABLEONINDDEVICE" | translate }} </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container>
              <div class="row mt-4">
                <div class="mt-4">

                  <div class="d-flex align-items-center gap-3">
                    <span class="fw-bold" style="font-weight: 400; font-size: 18px;">
                      {{ 'DASHBOARD.SELECTDEVICE' | translate }}
                    </span>

                    <div class="device-select-wrapper">

                      <ng-select #smartParentingReportDevices class="bg-transparent custom w-100" bindLabel="deviceName"
                        bindValue="id" [clearable]="false" [searchable]="false" [(ngModel)]="deviceid"
                        (ngModelChange)="getDevicesId($event, 'PARENTAL')" *ngIf="devicesList?.length != 0">

                        <ng-container *ngFor="let value of devicesList">
                          <ng-option *ngIf="value.deviceType === 'MOBILE'" [value]="value.id"
                            title="{{ value.deviceName }}">

                            <span>
                              {{ value?.deviceName?.length > 30
                              ? value?.deviceName.slice(0, 30) + '...'
                              : value?.deviceName }}
                            </span>

                          </ng-option>
                        </ng-container>

                      </ng-select>

                      <select class="w-100" [(ngModel)]="deviceid" (ngModelChange)="getDevicesId($event, 'PARENTAL')"
                        *ngIf="devicesList?.length == 0">

                        <option value="" disabled>
                          {{ 'ACTIVITYHISTORY.NODEVICES' | translate }}
                        </option>

                      </select>

                    </div>
                  </div>

                </div>

                <div class="col-md-12">
                  <ng-container *ngIf="showPremium">
                    <!-- Smart Paretal report Premium State -->
                    <div class="mt-4 bg-white p-3" style="border-radius: 12px;">
                      <div class="col-sm-12 relative">
                        <div class="mt-5 pt-3">
                          <div class="mb-3 text-center">
                            <div class="mt-2">
                              <span><img src="./assets/images/upgradeToPremium.svg" alt=""></span>
                            </div>
                            <div class="mt-2 pt-1 pb-1">
                              <span *ngIf="status === 'Free version'" class="empty-report-text">{{
                                "DASHBOARD.PREMIUMFEATUREUPGARDE" | translate }}</span>
                              <span *ngIf="status === 'LICENSE_EXPIRED'" class="empty-report-text"> {{
                                "DASHBOARD.PREMIUMFEATURERENEW" | translate }} </span>
                            </div>
                            <div class="mt-2 pt-1">
                              <button *ngIf="status === 'Free version'" (click)="navigateToRenew()"
                                class="submit-btn bg-orgclr py-2 px-4 add-device shadow-none">
                                {{ "LICENSESUMMARY.UPGRADE" | translate }}
                              </button>
                              <button *ngIf="status === 'LICENSE_EXPIRED'" (click)="navigateToRenew()"
                                class="submit-btn bg-orgclr py-2 px-4 add-device shadow-none">
                                {{ "LICENSESUMMARY.RENEW" | translate }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="col-md-6">
                  <ng-container *ngIf="restAppChart && !showPremium">
                    <!-- Attempts to access restricted apps -->
                    <div class="mt-3 bg-white p-3 border-radius-6">
                      <div class="col-sm-12 relative">
                        <div class="border-bottom negative_padding">
                          <div class=" mt-3 ms-4 text_20_600 relative">
                            <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                                  src="./assets/images/hitIcon.svg" alt=""></span>{{
                              "PARENTALREPORTS.ATTEMPTSTORESTAPP" |
                              translate
                              }}</span>
                            <span class="cursor-pointer" style="position: absolute;right: 16px;"
                              (click)="openTable('restAppReport')"><img src="./assets/images/tableIconOrg.svg"></span>
                          </div>
                          <div class="mb-3 ms-4 text_20_600 ">
                            <span> {{ totalAppHits }} </span>
                            <span>{{ "PARENTALREPORTS.ATTEMPTS" | translate }}<span class="ms-1"
                                style="font-weight: 400;font-size: 12px;">{{
                                "DASHBOARD.INLAST7DAYS" | translate }}</span> </span>
                          </div>
                        </div>
                        <div class="relative mt-3">
                          <span class="ms-4" style="font-size: 14px;font-weight: 400;">{{ "PARENTALREPORTS.TOP5CAT" |
                            translate
                            }}</span>
                        </div>
                        <div class="chart-container mt-0">
                          <canvas id="parentalRestrictedAppsChart" width="400" height="230"></canvas>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!restAppChart && parentalDeviceToggle && !showPremium">
                    <!-- Attempts to access restricted apps Empty State -->
                    <div class="mt-3 bg-white p-3 border-radius-6">
                      <div class="col-sm-12 relative">
                        <div class="border-bottom mb-5 negative_padding">
                          <div class=" mt-3 ms-4 text_20_600 relative mb-4 pb-3">
                            <span style="font-weight: 400;font-size: 18px;"><span class="me-1 pb-2"><img class="pb-1"
                                  src="./assets/images/hitIcon.svg" alt=""></span>{{
                              "PARENTALREPORTS.ATTEMPTSTORESTAPP" |
                              translate
                              }}</span>
                          </div>
                          <div class="mt-3 mb-3 ms-4 text_20_600 ">
                          </div>
                        </div>
                        <div class="relative mt-3">
                        </div>
                        <div class="">
                          <div class="mb-3 text-center">
                            <div class="mt-4">
                              <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                            </div>
                            <div class="mt-3 mb-4 pb-1">
                              <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="!restAppChart && !parentalDeviceToggle && !showPremium">
                    <!-- Attempts to access restricted apps Toggle State -->
                    <div class="mt-3 bg-white p-3 border-radius-6">
                      <div class="col-sm-12 relative">
                        <div class="border-bottom negative_padding mb-5">
                          <div class=" mt-3 ms-4 text_20_600 relative mb-4 pb-3">
                            <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                                  src="./assets/images/hitIcon.svg" alt=""></span>{{
                              "PARENTALREPORTS.ATTEMPTSTORESTAPP" |
                              translate
                              }}</span>
                          </div>
                          <div class="mt-2 mb-3 ms-4 text_20_600 ">
                          </div>
                        </div>
                        <div class="relative mt-3">
                        </div>
                        <div class="">
                          <div class="mb-0 text-center">
                            <div class="mt-3">
                              <span><img src="./assets/images/enableToggle.svg" alt=""></span>
                            </div>
                            <div class="mt-3 mb-0 pb-1">
                              <span class="empty-report-text">{{ "DASHBOARD.ENABLEPARENTALSETTINGS" | translate
                                }}</span>
                            </div>
                            <div class="mb-1">
                              <span> {{ "DASHBOARD.ENABLEONINDDEVICE" | translate }} </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="col-md-6">
                  <ng-container *ngIf="restWebChart && !showPremium">
                    <!-- Attempts to access restricted websites -->
                    <div class="mt-3 bg-white p-3 border-radius-6">
                      <div class="col-sm-12 relative">
                        <div class="border-bottom negative_padding">
                          <div class=" mt-3 ms-4 text_20_600 relative">
                            <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                                  src="./assets/images/hitIcon.svg" alt=""></span>{{
                              "PARENTALREPORTS.ATTEMPTSTORESTWEB" |
                              translate
                              }}</span>
                            <span class="cursor-pointer" style="position: absolute;right: 16px;"
                              (click)="openTable('restWebReport')"><img src="./assets/images/tableIconOrg.svg"></span>
                          </div>
                          <div class="mb-3 ms-4 text_20_600 ">
                            <span> {{ totalWebHits }} </span>
                            <span>{{ "PARENTALREPORTS.ATTEMPTS" | translate }}<span class="ms-1"
                                style="font-weight: 400;font-size: 12px;">{{
                                "DASHBOARD.INLAST7DAYS" | translate }}</span> </span>
                          </div>
                        </div>
                        <div class="relative mt-3">
                          <span class="ms-4" style="font-size: 14px;font-weight: 400;">{{ "PARENTALREPORTS.TOP5CAT" |
                            translate
                            }}</span>
                        </div>
                        <div class="chart-container mt-0">
                          <canvas id="parentalRestrictedWebChart" width="400" height="230"></canvas>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!restWebChart && parentalDeviceToggle && !showPremium">
                    <!-- Attempts to access restricted websites Empty State -->
                    <div class="mt-3 bg-white p-3 border-radius-6">
                      <div class="col-sm-12 relative">
                        <div class="border-bottom negative_padding">
                          <div class=" mt-3 ms-4 text_20_600 relative">
                            <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                                  src="./assets/images/hitIcon.svg" alt=""></span>{{
                              "PARENTALREPORTS.ATTEMPTSTORESTWEB" |
                              translate
                              }}</span>
                          </div>
                          <div class="mt-2 mb-4 pb-2 ms-4 text_20_600 ">
                          </div>
                        </div>
                        <div class="relative mt-5 mb-2">
                        </div>
                        <div class="">
                          <div class="mb-3 text-center">
                            <div class="mt-4">
                              <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                            </div>
                            <div class="mt-3 mb-4 pb-1">
                              <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!restWebChart && !parentalDeviceToggle && !showPremium">
                    <!-- Attempts to access restricted websites Toggle State -->
                    <div class="mt-3 bg-white p-3 border-radius-6">
                      <div class="col-sm-12 relative">
                        <div class="border-bottom negative_padding mb-5">
                          <div class=" mt-3 ms-4 text_20_600 relative mb-4 pb-3">
                            <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                                  src="./assets/images/hitIcon.svg" alt=""></span>{{
                              "PARENTALREPORTS.ATTEMPTSTORESTWEB" |
                              translate
                              }}</span>
                          </div>
                          <div class="mt-2 mb-3 ms-4 text_20_600 ">
                          </div>
                        </div>
                        <div class="relative mt-3">
                        </div>
                        <div class="">
                          <div class="mb-0 text-center">
                            <div class="mt-3">
                              <span><img src="./assets/images/enableToggle.svg" alt=""></span>
                            </div>
                            <div class="mt-3 mb-0 pb-1">
                              <span class="empty-report-text">{{ "DASHBOARD.ENABLEPARENTALSETTINGS" | translate
                                }}</span>
                            </div>
                            <div class="mb-1">
                              <span> {{ "DASHBOARD.ENABLEONINDDEVICE" | translate }} </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                </div>
              </div>
            </ng-container>
            <ng-container>
              <div class="row">
                <div class="col-md-6">
                  <ng-container *ngIf="appUsageChart && !showPremium">
                    <!-- Usage report for app -->
                    <div class="mt-4 bg-white p-3 border-radius-6">
                      <div class="col-sm-12 relative">
                        <div class="border-bottom negative_padding">
                          <div class=" mt-3 ms-4 text_20_600 relative">
                            <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                                  src="./assets/images/hitIcon.svg" alt=""></span>{{
                              "PARENTALREPORTS.USAGEREPORTAPP" |
                              translate
                              }}</span>
                            <span *ngIf="appUsageValue[0] != 0" class="cursor-pointer"
                              style="position: absolute;right: 16px;" (click)="openTable('appUsageReport')"><img
                                src="./assets/images/tableIconOrg.svg"></span>
                          </div>
                          <div class="mb-3 ms-4 text_20_600 ">
                            <span>{{ totalAppUsage }}<span class="ms-1" style="font-weight: 400;font-size: 12px;">{{
                                "DASHBOARD.INLAST7DAYS" | translate }}</span> </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-5 mt-5 ms-3 mb-3 me-3">
                            <canvas id="AppUsageChartData" width="400" height="200"></canvas>
                          </div>
                          <div class="col-md-5 mt-5">
                            <div *ngIf="appUsageCat[0] && appUsageValue[0]">
                              <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                                    src="./assets/images/blueRoundIcon.svg" alt=""></span><span>{{
                                  appUsageCat[0].length > 15 ? appUsageCat[0].slice(0,15) + "..." : appUsageCat[0]
                                  }}&nbsp;<span class="text_14_600">{{ appUsageValue[0] + "%" }}</span></span></div>
                              <!-- <div class="ms-3 text_14_600 ">{{ appUsageValue[0] + "%" }}</div> -->
                            </div>
                            <div *ngIf="appUsageCat[1] && appUsageValue[1]">
                              <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                                    src="./assets/images/darkBlueRoundIcon.svg" alt=""></span><span>{{
                                  appUsageCat[1].length > 15 ? appUsageCat[1].slice(0,15) + "..." : appUsageCat[1]
                                  }}&nbsp;<span class="text_14_600">{{ appUsageValue[1] + "%" }}</span></span></div>
                              <!-- <div class="ms-3 text_14_600 ">{{ appUsageValue[1] + "%" }}</div> -->
                            </div>
                            <div *ngIf="appUsageCat[2] && appUsageValue[2]">
                              <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                                    src="./assets/images/pinkRoundIcon.svg" alt=""></span><span>{{ appUsageCat[2].length
                                  > 15 ? appUsageCat[2].slice(0,15) + "..." : appUsageCat[2]
                                  }}&nbsp;<span class="text_14_600">{{ appUsageValue[2] + "%" }}</span></span></div>
                              <!-- <div class="ms-3 text_14_600 ">{{ appUsageValue[2] + "%" }}</div> -->
                            </div>
                            <div *ngIf="appUsageCat[3] && appUsageValue[3]">
                              <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                                    src="./assets/images/voiletRoundIcon.svg" alt=""></span><span>{{
                                  appUsageCat[3].length > 15 ? appUsageCat[3].slice(0,15) + "..." : appUsageCat[3]
                                  }}&nbsp;<span class="text_14_600">{{ appUsageValue[3] + "%" }}</span></span></div>
                            </div>
                            <div *ngIf="appUsageCat[4] && appUsageValue[4]">
                              <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                                    src="./assets/images/yellowRoundIcon.svg" alt=""></span><span>{{
                                  appUsageCat[4].length > 15 ? appUsageCat[4].slice(0,15) + "..." : appUsageCat[4]
                                  }}&nbsp;<span class="text_14_600">{{ appUsageValue[4] + "%" }}</span></span></div>
                            </div>
                            <div *ngIf="appUsageCat[5] && appUsageValue[5]">
                              <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                                    src="./assets/images/redRoundIcon.svg" alt=""></span><span>{{ appUsageCat[5].length
                                  > 15 ? appUsageCat[5].slice(0,15) + "..." : appUsageCat[5]
                                  }}&nbsp;<span class="text_14_600">{{ appUsageValue[5] + "%" }}</span></span></div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!appUsageChart && parentalDeviceToggle && !showPremium">
                    <!-- Usage report for app empty state -->
                    <div class="mt-4 bg-white p-3 border-radius-6">
                      <div class="col-sm-12 relative">
                        <div class="border-bottom negative_padding">
                          <div class=" mt-3 ms-4 text_20_600 relative">
                            <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                                  src="./assets/images/hitIcon.svg" alt=""></span>{{
                              "PARENTALREPORTS.USAGEREPORTAPP" |
                              translate
                              }}</span>
                          </div>
                          <div class="mt-2 mb-4 pb-2 ms-4 text_20_600 ">
                          </div>
                        </div>
                        <div class="relative mt-5 mb-2">
                        </div>
                        <div class="">
                          <div class="mt-2 mb-4 text-center">
                            <div class="mt-4">
                              <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                            </div>
                            <div class="mt-3 mb-4 pb-2">
                              <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="!appUsageChart && !parentalDeviceToggle && !showPremium">
                    <!-- Usage report for app Toggle State -->
                    <div class="mt-4 bg-white p-3 border-radius-6">
                      <div class="col-sm-12 relative">
                        <div class="border-bottom negative_padding mb-5">
                          <div class=" mt-3 ms-4 text_20_600 relative mb-4 pb-3">
                            <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                                  src="./assets/images/hitIcon.svg" alt=""></span>{{
                              "PARENTALREPORTS.USAGEREPORTAPP" |
                              translate
                              }}</span>
                          </div>
                          <div class="mt-2 mb-3 ms-4 text_20_600 ">
                          </div>
                        </div>
                        <div class="relative mt-3">
                        </div>
                        <div class="">
                          <div class="mb-0 text-center">
                            <div class="mt-3">
                              <span><img src="./assets/images/enableToggle.svg" alt=""></span>
                            </div>
                            <div class="mt-3 mb-0 pb-1">
                              <span class="empty-report-text">{{ "DASHBOARD.ENABLEPARENTALSETTINGS" | translate
                                }}</span>
                            </div>
                            <div class="mb-1">
                              <span> {{ "DASHBOARD.ENABLEONINDDEVICE" | translate }} </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="col-md-6">
                  <ng-container *ngIf="webUsageChart && !showPremium">
                    <!-- Usage report for web -->
                    <div class="mt-4 bg-white p-3 border-radius-6">
                      <div class="col-sm-12 relative">
                        <div class="border-bottom negative_padding">
                          <div class=" mt-3 ms-4 text_20_600 relative">
                            <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                                  src="./assets/images/hitIcon.svg" alt=""></span>{{
                              "PARENTALREPORTS.USAGEREPORTWEB" |
                              translate
                              }}</span>
                            <span class="cursor-pointer" style="position: absolute;right: 16px;"
                              (click)="openTable('webUsageReport')"><img src="./assets/images/tableIconOrg.svg"></span>
                          </div>
                          <div class="mb-3 ms-4 text_20_600 ">
                            <span> {{ totalRestWebHits }} </span>
                            <span>{{ "PARENTALREPORTS.ATTEMPTS" | translate }}<span class="ms-1"
                                style="font-weight: 400;font-size: 12px;">{{
                                "DASHBOARD.INLAST7DAYS" | translate }}</span> </span>
                          </div>
                        </div>
                        <div class="row ms-2">
                          <div class="col-md-5 mt-5 mb-3 me-4">
                            <canvas id="websiteUsageChart" width="400" height="200"></canvas>
                          </div>
                          <div class="col-md-5 mt-4">
                            <div *ngIf="webCat[0] && webCatValue[0]">
                              <div class="mt-4"><span class="me-1"><img class="pb-1 me-1"
                                    src="./assets/images/blueRoundIcon.svg" alt=""></span><span>{{ webCat[0].length >
                                  15
                                  ? webCat[0].slice(0,20) + "..." : webCat[0]
                                  }}&nbsp;<span class="text_14_600">{{ webCatValue[0] + "%" }}</span></span></div>
                            </div>
                            <div *ngIf="webCat[1] && webCatValue[1]">
                              <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                                    src="./assets/images/darkBlueRoundIcon.svg" alt=""></span><span class="scoretype">{{
                                  webCat[1].length > 20 ? webCat[1].slice(0,20) + "..." : webCat[1]
                                  }}&nbsp;<span class="text_14_600">{{webCatValue[1] + "%" }}</span></span></div>
                            </div>
                            <div *ngIf="webCat[2] && webCatValue[2]">
                              <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                                    src="./assets/images/pinkRoundIcon.svg" alt=""></span><span>{{ webCat[2].length > 20
                                  ? webCat[2].slice(0,20) + "..." : webCat[2]
                                  }}&nbsp;<span class="text_14_600">{{ webCatValue[2] + "%" }}</span></span></div>
                            </div>
                            <div *ngIf="webCat[3] && webCatValue[3]">
                              <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                                    src="./assets/images/voiletRoundIcon.svg" alt=""></span><span>{{ webCat[3].length >
                                  20 ? webCat[3].slice(0,20) + "..." : webCat[3]
                                  }}&nbsp;<span class="text_14_600">{{ webCatValue[3] + "%" }}</span></span></div>
                            </div>
                            <div *ngIf="webCat[4] && webCatValue[4]">
                              <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                                    src="./assets/images/yellowRoundIcon.svg" alt=""></span><span>{{ webCat[4].length >
                                  20 ? webCat[4].slice(0,20) + "..." : webCat[4]
                                  }}&nbsp;<span class="text_14_600">{{ webCatValue[4] + "%" }}</span></span></div>
                            </div>
                            <div *ngIf="webCat[5] && webCatValue[5]">
                              <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                                    src="./assets/images/redRoundIcon.svg" alt=""></span><span>{{ webCat[5].length > 20
                                  ? webCat[5].slice(0,20) + "..." : webCat[5]
                                  }}&nbsp;<span class="text_14_600">{{ webCatValue[5] + "%" }}</span></span></div>
                            </div>
                          </div>
                          <!-- <div class="col-md-3 mt-5">
                            <div *ngIf="webCat[1] && webCatValue[1]">
                              <div class="mt-4"><span class="me-1"><img class="pb-1 me-1"
                                    src="./assets/images/darkBlueRoundIcon.svg" alt=""></span><span class="scoretype">{{
                                  webCat[1].length > 7 ? webCat[1].slice(0,7) + "..." : webCat[1]
                                  }}</span></div>
                              <div class="ms-3 text_14_600 ">{{
                                webCatValue[1] + "%" }}
                              </div>
                            </div>
                            <div *ngIf="webCat[3] && webCatValue[3]">
                              <div class="mt-3"><span class="me-1"><img class="pb-1 me-1"
                                    src="./assets/images/voiletRoundIcon.svg" alt=""></span><span>{{ webCat[3].length >
                                  7 ? webCat[3].slice(0,7) + "..." : webCat[3]
                                  }}</span></div>
                              <div class="ms-3 text_14_600 ">{{ webCatValue[3] + "%" }}</div>
                            </div>
                            <div *ngIf="webCat[5] && webCatValue[5]">
                              <div class="mt-3"><span class="me-1"><img class="pb-1 me-1"
                                    src="./assets/images/redRoundIcon.svg" alt=""></span><span>{{ webCat[5].length > 7
                                  ? webCat[5].slice(0,7) + "..." : webCat[5]
                                  }}</span></div>
                              <div class="ms-3 text_14_600 ">{{ webCatValue[5] + "%" }}</div>
                            </div>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!webUsageChart && parentalDeviceToggle && !showPremium">
                    <!-- Usage report for web empty state -->
                    <div class="mt-4 bg-white p-3 border-radius-6">
                      <div class="col-sm-12 relative">
                        <div class="border-bottom negative_padding">
                          <div class=" mt-3 ms-4 text_20_600 relative">
                            <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                                  src="./assets/images/hitIcon.svg" alt=""></span>{{
                              "PARENTALREPORTS.USAGEREPORTWEB" |
                              translate
                              }}</span>
                          </div>
                          <div class="mt-2 mb-4 pb-2 ms-4 text_20_600 ">
                          </div>
                        </div>
                        <div class="relative mt-5 mb-2">
                        </div>
                        <div class="">
                          <div class="mt-2 mb-4 text-center">
                            <div class="mt-4">
                              <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                            </div>
                            <div class="mt-3 mb-4 pb-2">
                              <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="!webUsageChart && !parentalDeviceToggle && !showPremium">
                    <!-- Usage report for web Toggle State -->
                    <div class="mt-4 bg-white p-3 border-radius-6">
                      <div class="col-sm-12 relative">
                        <div class="border-bottom negative_padding mb-5">
                          <div class=" mt-3 ms-4 text_20_600 relative mb-4 pb-3">
                            <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                                  src="./assets/images/hitIcon.svg" alt=""></span>{{
                              "PARENTALREPORTS.USAGEREPORTWEB" |
                              translate
                              }}</span>
                          </div>
                          <div class="mt-2 mb-3 ms-4 text_20_600 ">
                          </div>
                        </div>
                        <div class="relative mt-3">
                        </div>
                        <div class="">
                          <div class="mb-0 text-center">
                            <div class="mt-3">
                              <span><img src="./assets/images/enableToggle.svg" alt=""></span>
                            </div>
                            <div class="mt-3 mb-0 pb-1">
                              <span class="empty-report-text">{{ "DASHBOARD.ENABLEPARENTALSETTINGS" | translate
                                }}</span>
                            </div>
                            <div class="mb-1">
                              <span> {{ "DASHBOARD.ENABLEONINDDEVICE" | translate }} </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      <!-- Threat Report In insights start from here -->

      <ng-container *ngIf="isThreatReport">
        <!-- threat report state -->
        <div class="mt-3 bg-white p-3" style="border-radius: 12px;" *ngIf="threatsdetected > 0">
          <div class="col-sm-12 relative">
            <div class="border-bottom negative_padding">
              <div class="ms-4 text_20_600 ">
                <span class="ms-2">
                  <img class="me-0 threat-detect-image" src="./assets/images/threatImage.svg" alt="">
                </span>
                <span class="me-5 threat-detect-insights ">
                  {{ "DASHBOARD.THREATDETECT" | translate }}
                </span>
              </div>
              <div class="mb-3 ms-4 text_20_600">
                <span class="chartTitle  " [ngClass]="totalCount >10 ? 'ms-2' : 'ms-2'">
                  {{ totalCount }}
                </span>
                <span class="last7-dashboard ">
                  {{ "DASHBOARD.INLAST7DAYS" | translate }}
                </span>
              </div>
            </div>
            <div class="relative">
              <div class="row-reverse">
                <div class="mt-2 flex-container" *ngFor="let item of deviceNameListMap | keyvalue">
                  <div class="mb-1 me-2 " [title]="item.key">
                    <span class=" me-1 mt-1"><img class="flex-container" src="{{item.value}}" alt=""></span>
                    <span class="mb-1 me-1"> {{ isString(item.key) ? item.key.slice(0, 7) : '' }}...</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="chart-container mt-3">
              <canvas id="threatReportChart" width="400" height="230"></canvas>
            </div>
          </div>
        </div>

        <!-- threat report  Empty State -->
        <div class="mt-3 bg-white p-3" style="border-radius: 12px;" *ngIf="threatsdetected < 1">
          <div class="col-sm-12 relative">
            <div class="border-bottom negative_padding ">
              <div class=" mt-2 ms-4 text_20_600 mb-5 ">
                <span class="ms-2">
                  <img class="me-0 threat-detect-image" src="./assets/images/threatImage.svg" alt="">
                </span>
                <span class="me-5 threat-detect-insights ">
                  {{ "DASHBOARD.THREATDETECT" | translate }}
                </span>
              </div>
            </div>
            <div class="mt-5">
              <div class="mb-3 text-center">
                <div class="mt-4">
                  <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                </div>
                <div class="mt-3 mb-4 pb-1">
                  <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class=" mb-3">
          <!-- devicelist above small threat report -->
          <div class="mt-4 mb-0">
            <!-- Threat Device Dropdown -->
            <div class="mt-4">

              <div class="d-flex align-items-center gap-3">
                <span class="fw-bold" style="font-weight: 400; font-size: 18px;">
                  {{ 'DASHBOARD.SELECTDEVICE' | translate }}
                </span>

                <div class="device-select-wrapper">
                  <ng-select #threatReportDevices class="bg-transparent custom w-100" bindLabel="deviceName"
                    bindValue="id" [clearable]="false" [searchable]="false" [(ngModel)]="deviceid" [items]="devicesList"
                    (ngModelChange)="getDevicesId($event, 'THREAT')" *ngIf="devicesList?.length != 0">

                    <ng-template ng-label-tmp let-item="item">
                      <span>
                        {{ item?.deviceName?.length > 30
                        ? item?.deviceName.slice(0, 30) + '...'
                        : item?.deviceName }}
                      </span>
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item">
                      <span title="{{ item?.deviceName }}">
                        {{ item?.deviceName.length > 30
                        ? item?.deviceName.slice(0, 30) + '...'
                        : item?.deviceName }}
                      </span>
                    </ng-template>

                  </ng-select>

                  <select class="w-100" [(ngModel)]="deviceid" (ngModelChange)="getDevicesId($event, 'THREAT')"
                    *ngIf="devicesList?.length == 0">

                    <option value="" disabled>
                      {{ 'ACTIVITYHISTORY.NODEVICES' | translate }}
                    </option>

                  </select>
                </div>
              </div>

            </div>
          </div>


          <div class="row">

            <div class="col-md-6">
              <!-- device wise threat detected  -->
              <div class="mt-3 bg-white p-3 border-radius-6" *ngIf="!norecordsThreatReportArea">
                <div class="border-bottom  mt-1 negative_padding-threat mb-3 ">
                  <div class="ms-4 text_20_600 ">
                    <span>
                      <img class="me-0 threat-detect-image" src="./assets/images/threatImage.svg" alt="">
                    </span>
                    <span class="me-5 threat-detect-insights ">
                      {{ "DASHBOARD.THREATDETECT" | translate }}
                    </span>
                  </div>
                  <div class="mb-3 ms-4 text_20_600">
                    <span class="chartTitle">
                      {{ totalthreatDetectedCount }}
                    </span>
                    <span class="chartTitle-types"> {{ "PARENTALREPORTS.UNIQUE" | translate }}</span>
                    <span class="last7-dashboard ">
                      {{ "DASHBOARD.INLAST7DAYS" | translate }}
                    </span>
                  </div>
                </div>
                <div class=" mb-2">
                  <canvas id="smallThreatReportChart" height="220"></canvas>
                </div>
              </div>
              <!-- device wise threat detected  Empty State -->
              <div class="mt-3 bg-white p-3 border-radius-6" *ngIf="norecordsThreatReportArea">
                <div class="border-bottom mt-2">
                  <div class="ms-3 mb-5 text_20_600 ">
                    <span>
                      <img class="me-0 threat-detect-image" src="./assets/images/threatImage.svg" alt="">
                    </span>
                    <span class="me-5 threat-detect-insights ">
                      {{ "DASHBOARD.THREATDETECT" | translate }}
                    </span>
                  </div>
                </div>
                <div class="mb-2 text-center">
                  <div class="mt-4">
                    <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                  </div>
                  <div class="mt-3 mb-4">
                    <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <!-- device wise threat types detected  -->
              <div class="mt-3 bg-white p-3 border-radius-6" *ngIf="!norecordsThreatWebUsage">
                <div class="border-bottom negative_padding">
                  <div class=" mt-1 ms-3 text_20_600 ">
                    <span class="ms-3">
                      <img class="me-0 threat-detect-image" src="./assets/images/threatImage.svg" alt="">
                    </span>
                    <span class="me-0 threat-detect-insights ">
                      {{ "DASHBOARD.THREATTYPE" | translate }}
                    </span>
                    <div class="dropdown threat-tooltip cursor-pointer">
                      <img src="./assets/images/threatTypeIcon.svg" alt="" class="ms-0" />

                      <div class="threat-tooltip dropdown-content" *ngIf="deviceType == 'MOBILE'" i18n-title>
                        <div class="row">
                          <div class="col-sm-1 mt-0  me-4 ms-2">
                            <div class="threattooltiptitle">{{ "DASHBOARD.MALWARE" | translate }}</div>
                            <div class="threattooltiptitle mt-3 mb-1">{{ "DASHBOARD.ADWARE" | translate }}</div>
                            <div class="threattooltiptitle mt-4">{{ "DASHBOARD.PUA" | translate }}</div>
                            <div class="threattooltiptitle mt-2">{{ "DASHBOARD.VULNERABLE" | translate }}</div>
                          </div>
                          <div class="col-md-9 mt-0 ms-4">
                            <div class="mt-0 threattooltipdesc"> {{
                              "SETTINGS.THREATMESSAGE.MALWARE" |
                              translate }}</div>

                            <div class="mt-1 threattooltipdesc"> {{
                              "SETTINGS.THREATMESSAGE.ADWARE" | translate
                              }}</div>
                            <div class="mt-1 threattooltipdesc"> {{
                              "SETTINGS.THREATMESSAGE.PUA" | translate
                              }}</div>
                            <div class="mt-1 threattooltipdesc"> {{
                              "SETTINGS.THREATMESSAGE.VULNERABLE" | translate
                              }}</div>
                          </div>
                        </div>
                      </div>

                      <div class="threat-tooltip threat-tooltip-system dropdown-content" *ngIf="deviceType == 'SYSTEM'"
                        i18n-title>
                        <div class="row">
                          <div class="col-sm-1 mt-0  me-4 ms-2">
                            <div class="threattooltiptitle">{{ "DASHBOARD.MALWARE" | translate }}</div>
                            <div class="threattooltiptitle mt-3">{{ "DASHBOARD.ADWARE" | translate }}</div>
                            <div class="threattooltiptitle mt-3">{{ "DASHBOARD.RANSOMWARE" | translate }}</div>
                            <div class="threattooltiptitle mt-3">{{ "DASHBOARD.SUSPICIUSFILE" | translate }}</div>
                            <div class="threattooltiptitle mt-3">{{ "DASHBOARD.ROGUEWARE" | translate }}</div>
                            <div class="threattooltiptitle mt-3">{{ "DASHBOARD.RISKWARE" | translate }}</div>
                            <div class="threattooltiptitle mt-3">{{ "DASHBOARD.MALICIOUS" | translate }}</div>
                            <div class="threattooltiptitle mt-3">{{ "DASHBOARD.KEYLOGGERS" | translate }}</div>

                          </div>
                          <div class="col-md-9 mt-0 ms-4">
                            <div class="mt-0 threattooltipdesc"> {{
                              "SETTINGS.THREATMESSAGE.MALWARE" |
                              translate }}</div>

                            <div class="mt-0 threattooltipdesc"> {{
                              "SETTINGS.THREATMESSAGE.ADWARE" | translate
                              }}</div>
                            <div class="mt-0 threattooltipdesc"> {{
                              "SETTINGS.THREATMESSAGE.RANSOMWARE" | translate
                              }}</div>
                            <div class="mt-1 threattooltipdesc"> {{
                              "SETTINGS.THREATMESSAGE.SUSPICIUSFILE" | translate
                              }}</div>
                            <div class="mt-3 threattooltipdesc"> {{
                              "SETTINGS.THREATMESSAGE.ROGUEWARE" | translate
                              }}</div>
                            <div class="mt-0 threattooltipdesc"> {{
                              "SETTINGS.THREATMESSAGE.RISKWARE" | translate
                              }}</div>
                            <div class="mt-0 threattooltipdesc"> {{
                              "SETTINGS.THREATMESSAGE.MALICIOUS" | translate
                              }}</div>
                            <div class="mt-0 threattooltipdesc"> {{
                              "SETTINGS.THREATMESSAGE.KEYLOGGERS" | translate
                              }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-3 ms-3 text_20_600 ">
                    <span class="chartTitle ms-3"> {{ totalthreatDetectedCount }} </span>
                    <span class="chartTitle-types"> {{ "PARENTALREPORTS.TYPES" | translate }}</span>
                    <span class="ms-1" style="font-weight: 400;font-size: 12px;">{{
                      "DASHBOARD.INLAST7DAYS" | translate }}
                    </span>
                  </div>
                </div>
                <div class="row ms-2">
                  <div class="col-md-5 ms-3 mb-3 me-3 mt-5">
                    <canvas id="myChartWebUsage" width="400" height="200"></canvas>
                  </div>
                  <div class="col-md-5 mt-5 pt-2">
                    <div *ngIf="threatname[0] && threatcount[0]">
                      <div class="mt-0"><span class="me-1"><img class="pb-1 me-1"
                            src="./assets/images/threatTypesImage1.svg" alt=""></span><span>{{
                          threatname[0].length > 20 ? threatname[0].slice(0,20)+"...":
                          threatname[0] }}&nbsp;<span class="text_14_600 ">{{ threatcount[0]
                            }}</span></span>
                      </div>
                    </div>

                    <div *ngIf="threatname[1] && threatcount[1]">
                      <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                            src="./assets/images/threatTypesImage2.svg" alt=""></span><span>{{
                          threatname[1].length
                          > 20 ? threatname[1].slice(0,20) + "..." : threatname[1]
                          }}&nbsp;<span class="text_14_600 ">{{ threatcount[1]}}</span></span>
                      </div>
                    </div>

                    <div *ngIf="threatname[2] && threatcount[2]">
                      <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                            src="./assets/images/threatTypesImage3.svg" alt=""></span><span>{{
                          threatname[2].length
                          > 20 ? threatname[2].slice(0,20) + "..." : threatname[2]
                          }}&nbsp;<span class="text_14_600 ">{{ threatcount[2]}}</span></span>
                      </div>
                    </div>
                    <div *ngIf="threatname[3] && threatcount[3]">
                      <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                            src="./assets/images/threatTypesImage4.svg" alt=""></span><span>{{
                          threatname[3].length > 20 ? threatname[3].slice(0,20) + "..." :
                          threatname[3]
                          }}&nbsp;<span class="text_14_600 ">{{ threatcount[3] }}</span></span>
                      </div>
                    </div>
                    <div *ngIf="threatname[4] && threatcount[4]">
                      <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                            src="./assets/images/threatTypesImage5.svg" alt=""></span><span>{{
                          threatname[4].length > 20 ? threatname[4].slice(0,20) + "..." :
                          threatname[4]
                          }}&nbsp;<span class="text_14_600 ">{{ threatcount[4] }}</span></span>
                      </div>
                    </div>
                    <div *ngIf="threatname[5] && threatcount[5]">
                      <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                            src="./assets/images/threatTypesImage6.svg" alt=""></span><span>{{
                          threatname[5].length
                          > 20 ? threatname[5].slice(0,20) + "..." :threatname[5]
                          }}&nbsp;<span class="text_14_600 ">{{ threatcount[5] }}</span></span>
                      </div>
                    </div>
                    <div *ngIf="threatname[6] && threatcount[6]">
                      <div class="mt-3"><span class="me-1"><img class="pb-1 me-1" src="./assets/images/redRoundIcon.svg"
                            alt=""></span><span>{{ threatname[6].length > 20
                          ? threatname[6].slice(0,20) + "..." : threatname[6]
                          }} &nbsp;<span class="text_14_600 ">{{ threatcount[6] }}</span> </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- device wise threat types detected Empty sate  -->
              <div class="mt-3 bg-white p-3 border-radius-6" *ngIf="norecordsThreatWebUsage">
                <div class="border-bottom mt-2">
                  <div class=" mb-5 ms-1 text_20_600 ">
                    <span class="ms-3">
                      <img class="me-0 threat-detect-image" src="./assets/images/threatImage.svg" alt="">
                    </span>
                    <span class="me-0 threat-detect-insights ">
                      {{ "DASHBOARD.THREATTYPE" | translate }}
                    </span>
                  </div>
                </div>
                <div class="mb-2 text-center">
                  <div class="mt-4">
                    <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                  </div>
                  <div class="mt-3 mb-4">
                    <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                  </div>
                </div>
              </div>
            </div>




          </div>


          <!-- Table for Threat Report -->
          <div class="mt-3 bg-white p-3" style="border-radius: 12px;" *ngIf="virusReport?.length != 0">
            <div class="bg-white h-100 p-sm-3 pt-1 me-3">
              <div class="border-bottom negative_padding-threat-table ">
                <div class=" mt-0 ms-4 text_20_600 ">
                  <span style="font-weight: 400;font-size: 20px;"><span><img class="me-1 ms-2"
                        src="./assets/images/threatImage.svg" alt="" style="width: 22px; height: 22px;"></span>{{
                    "DASHBOARD.THREATS" | translate }}</span>
                </div>
                <!-- <div class=" mb-2 ms-4 text_20_600 ">
                  <span style="font-size: 12px; font-weight: 400;">
                    <span style="font-size: 20px; font-weight: 600;">
                      {{ totalActiveCount }}</span>
                    <span> {{ "PARENTALREPORTS.ACTIVE" | translate }}<span class="ms-1"
                        style="font-weight: 400;font-size: 12px;">{{
                        "DASHBOARD.INLAST7DAYS" | translate }}</span> </span>
                  </span>
                </div> -->

                <div class="mb-3 ms-3 text_20_600 ">
                  <span class="chartTitle ms-3"> {{ totalActiveCount }} </span>
                  <span class="chartTitle-types"> {{ "PARENTALREPORTS.ACTIVE" | translate }}</span>
                  <span class="ms-1" style="font-weight: 400;font-size: 12px;">{{
                    "DASHBOARD.INLAST7DAYS" | translate }}
                  </span>
                </div>
              </div>

              <!-- <div class="text-center border-0 h-100 mt-lg-0 mt-4"> -->
              <div class="scroller-threattable  px-0 mt-4">
                <table class="table reports-table act-history  mb-0 h-100" aria-describedby="Web Report Usage"
                  id="qh-virus-table">
                  <thead class="activity-header border-radius-6 fixedTableHeader"
                    style="font-size: 16px;border-style: hidden;">
                    <tr style="border-style: hidden" i18n-title>
                      <th style="font-size: 16px; align-content: center;">
                        <p class="text-center mb-2 me-5 ms-5 virusName w-10rem">
                          {{ "PARENTALREPORTS.DATE" | translate }}
                        </p>
                      </th>
                      <th style="font-size: 16px; align-content: center;">
                        <span *ngIf="this.deviceType == 'MOBILE'">
                          <p class="mb-2 me-4 ms-3 virusName w-10rem">{{
                            "PARENTALREPORTS.VIRUSDETAILS" | translate }}</p>
                        </span>
                        <span *ngIf="this.deviceType == 'SYSTEM'">
                          <p class="mb-2 me-4 ms-3 virusName w-10rem">{{
                            "PARENTALREPORTS.THREATDETAILS" | translate }}</p>
                        </span>
                      </th>
                      <th style="font-size: 16px; align-content: center;">
                        <p class="mb-2 me-5 ms-5 virusName w-10rem">{{ "PARENTALREPORTS.VIRUSTYPE"| translate }}
                        </p>
                      </th>
                      <th style="font-size: 16px; align-content: center;">
                        <p class="mb-2 me-0 ms-5 virusName w-10rem"> {{
                          "PARENTALREPORTS.STATUS"| translate
                          }}
                        </p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="text-capitalize" *ngFor="let i of virusReport">
                      <td style="border-bottom-width: inherit;">
                        <p class=" mb-2 me-0 ms-5 virusName w-10rem"> {{ i.date }}
                        </p>
                      </td>
                      <td style="border-bottom-width: inherit;">
                        <ng-container *ngIf="i?.threatReportList?.length > 3">
                          <div class=" " *ngFor="
                                    let webUsesReport of i.threatReportList.slice(
                                      
                                    )
                                  ">
                            <div class="">
                              <p class=" mb-2 me-0 ms-3 virusName w-10rem" *ngIf="this.deviceType == 'MOBILE'"
                                title="{{ webUsesReport?.key }}">
                                {{ webUsesReport?.key }}
                              </p>
                              <p class=" mb-2 me-0 ms-3 virusName w-10rem" *ngIf="this.deviceType == 'SYSTEM'"
                                title="{{ webUsesReport?.virusType }}">
                                {{ webUsesReport?.virusType }}
                              </p>
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="i?.threatReportList?.length <= 3">
                          <div *ngFor="
                                    let webUsesReport of i.threatReportList
                                  ">
                            <p class=" mb-2 me-0 ms-3 virusName w-10rem" *ngIf="this.deviceType == 'MOBILE'"
                              title="{{ webUsesReport?.key }}">
                              {{ webUsesReport?.key }}
                            </p>
                            <p class=" mb-2 me-0 ms-3 virusName w-10rem" *ngIf="this.deviceType == 'SYSTEM'"
                              title="{{ webUsesReport?.virusType }}">
                              {{ webUsesReport?.virusType }}
                            </p>
                          </div>
                        </ng-container>
                      </td>
                      <td style="border-bottom-width: inherit;">
                        <ng-container *ngIf="i?.threatReportList?.length > 3">
                          <div class=" " *ngFor="
                                  let webUsesReport of i.threatReportList.slice(
                                  )
                                ">
                            <p class=" mb-2 me-0 ms-5 virusName w-10rem" *ngIf="this.deviceType == 'MOBILE'">{{
                              webUsesReport?.virusType}}</p>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="i?.threatReportList?.length <= 3">
                          <div class=" " *ngFor="
                                  let webUsesReport of i.threatReportList
                                ">
                            <p class=" mb-2 me-0 ms-5 virusName w-10rem" *ngIf="this.deviceType == 'MOBILE'">{{
                              webUsesReport?.virusType}}</p>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="i?.threatReportList?.length <= 3">
                          <div class=" " *ngFor="
                                  let webUsesReport of i.threatReportList
                                ">
                            <p class=" mb-2 me-0 ms-5 virusName w-10rem" *ngIf="this.deviceType == 'SYSTEM'">{{
                              webUsesReport?.key |
                              titlecase }}</p>
                          </div>
                        </ng-container>
                      </td>
                      <td style="border-bottom-width: inherit;">
                        <ng-container *ngIf="i?.threatReportList?.length > 3">
                          <div class="" *ngFor="
                                  let webUsesReport of i.threatReportList.slice()">
                            <p class=" mb-2 me-0 ms-5 virusName w-10rem">{{
                              webUsesReport?.status |
                              translate }}</p>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="i?.threatReportList?.length <= 3">
                          <div class="" *ngFor="
                                  let webUsesReport of i.threatReportList
                                ">
                            <p class=" mb-2 me-0 ms-5 virusName w-10rem">{{
                              webUsesReport?.status |
                              translate }}</p>
                          </div>
                        </ng-container>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </div>
          <!-- Table for Threat Report Empty state -->
          <div class="mt-3 bg-white p-3" style="border-radius: 12px;" *ngIf="virusReport?.length == 0">
            <div class="bg-white h-100 p-sm-3 pt-1 me-3">
              <div class="border-bottom negative_padding-threat-table mt-0">
                <div class="  ms-4 text_20_600 mb-4">
                  <span style="font-weight: 400;font-size: 18px;"><span>
                      <img class="me-0 mb-1 threat-detect-image" src="./assets/images/threatImage.svg" alt="">
                    </span>
                  </span>
                  <span class="me-0 threat-detect-insights "> {{
                    "DASHBOARD.THREATS" |
                    translate }} </span>

                </div>
              </div>
              <div class="bg-white p-3 mt-3" style="border-radius: 12px;">
                <div class="col-sm-12 text-center">
                  <div class="mt-5">
                    <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                  </div>
                  <div class="mt-2 mb-5">
                    <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>


      <ng-container *ngIf="isFirewallReport">

        <div class="mb-3">
          <div class="mt-4 mb-0">

            <!-- Firewall Protection Device Dropdown -->
            <div class="mt-4">

              <div class="d-flex align-items-center gap-3">
                <span class="fw-bold" style="font-weight: 400; font-size: 20px;">
                  {{ 'DASHBOARD.SELECTDEVICE' | translate }}
                </span>

                <div class="device-select-wrapper">

                  <ng-select #firewallSystem class="bg-transparent custom w-100" bindLabel="deviceName" bindValue="id"
                    [clearable]="false" [searchable]="false" [(ngModel)]="systemId" [items]="systemList"
                    (ngModelChange)="firewallTableData($event)" *ngIf="systemList?.length != 0">

                    <ng-template ng-label-tmp let-item="item">
                      <span>
                        {{ item?.deviceName?.length > 30
                        ? item?.deviceName.slice(0, 30) + '...'
                        : item?.deviceName }}
                      </span>
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item">
                      <span title="{{ item?.deviceName }}">
                        {{ item?.deviceName.length > 30
                        ? item?.deviceName.slice(0, 30) + '...'
                        : item?.deviceName }}
                      </span>
                    </ng-template>

                  </ng-select>

                  <select class="w-100" [(ngModel)]="systemId" (ngModelChange)="getDevicesId($event, 'FIREWALL')"
                    *ngIf="systemList?.length == 0">

                    <option value="" disabled>
                      {{ 'ACTIVITYHISTORY.NODEVICES' | translate }}
                    </option>

                  </select>

                </div>
              </div>

            </div>
          </div>
        </div>


        <div class="mt-3 bg-white p-3" style="border-radius: 12px;"
          *ngIf="firewallReport?.length != 0 && selectedSystem?.expirydays > 0">
          <div class="bg-white h-100 p-sm-3 pt-1 me-3">
            <div class="border-bottom negative_padding-threat-table ">
              <div class=" mt-0 ms-0 text_20_600 ">
                <span class="ms-3" style="font-weight: 400;font-size: 20px; "><span><img class="me-1 ms-2"
                      src="./assets/images/firewallImage.png" alt="" style="width: 22px; height: 22px;"></span>{{
                  "PARENTALREPORTS.FIREWALL" | translate }}</span>

                <div class="mb-3 text_20_600 " style="margin-left: 0.6rem;">
                  <span class="chartTitle ms-3"> {{ totalFirewallActiveCount }} </span>
                  <span class="chartTitle-types"> {{ "PARENTALREPORTS.ACTIVE" | translate }}</span>
                  <span class="ms-1" style="font-weight: 400;font-size: 12px;">{{
                    "DASHBOARD.INLAST7DAYS" | translate }}
                  </span>
                </div>
              </div>
            </div>

            <div class="scroller-threattable  px-3 mt-4">
              <table class="reports-table act-history  mb-0 h-100 w-100"
                style="border-collapse: separate; border-spacing: 0;" aria-describedby="Web Report Usage"
                id="qh-virus-table">
                <thead class="activity-header border-radius-6 fixedTableHeader"
                  style="font-size: 16px; border-style: hidden;">
                  <tr style="border-style: hidden;" i18n-title>
                    <th class="text-start px-3" style="border-top-left-radius: 4px; border-bottom-left-radius: 4px;">
                      <div class="d-flex  align-items-center">
                        <span class="me-1">{{ "PARENTALREPORTS.DATE" | translate }}</span>
                        <div class="sort-arrows">
                          <div class="arrows up" (click)="sortByDateAsc()" title="Sort Ascending"></div>
                          <div class="arrows down" (click)="sortByDateDesc()" title="Sort Descending"></div>
                        </div>
                      </div>
                    </th>
                    <th class="text-start px-3">
                      {{ "PARENTALREPORTS.VDBDATE" | translate }}
                    </th>
                    <th class="text-start px-3">
                      {{ "PARENTALREPORTS.APPLICATION" | translate }}
                    </th>
                    <th class="text-start px-3">
                      {{ "PARENTALREPORTS.FILEPATH" | translate }}
                    </th>
                    <th class="text-start px-3" style="border-top-right-radius: 4px; border-bottom-right-radius: 4px;">
                      {{ "PARENTALREPORTS.ACTIONTAKEN" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="text-capitalize" *ngFor="let i of firewallReport">
                    <td class=" pe-0 ps-3 py-3" style="border-bottom-width: inherit;">{{ i.dateTime }}
                    </td>
                    <td class=" pe-0 ps-3 py-3" style="border-bottom-width: inherit; ">{{ i.vdbDate }}
                    </td>
                    <td class=" pe-0 ps-3 py-3" style="border-bottom-width: inherit; ">{{ i.programName
                      }}</td>
                    <td class=" pe-0 ps-3 py-3" style="border-bottom-width: inherit;">{{ i.programPath
                      }}</td>
                    <td class=" pe-0 ps-3 py-3" style="border-bottom-width: inherit; ">{{
                      actionLabelMap[i.actionTaken] ||
                      i.actionTaken | translate }}</td>
                  </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>

        <div class="mt-3 bg-white p-3" style="border-radius: 12px;"
          *ngIf="firewallReport?.length == 0 && selectedSystem?.expirydays > 0">
          <div class="bg-white h-100 p-sm-3 pt-1 me-3">
            <div class="border-bottom negative_padding-threat-table mt-0">
              <div class="  ms-4 text_20_600 mb-4">
                <span style="font-weight: 400;font-size: 18px;"><span>
                    <img class="me-0 mb-1 threat-detect-image" src="./assets/images/firewallImage.png" alt="">
                  </span>
                </span>
                <span class="me-0 threat-detect-insights "> {{
                  "PARENTALREPORTS.FIREWALL" |
                  translate }} </span>

              </div>
            </div>
            <div class="bg-white p-3 mt-3" style="border-radius: 12px;">
              <div class="col-sm-12 text-center">
                <div class="mt-5">
                  <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                </div>
                <div class="mt-2 mb-5">
                  <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-3 bg-white p-3" style="border-radius: 12px;" *ngIf="selectedSystem?.expirydays <= 0">
          <div class="bg-white h-100 p-sm-3 pt-1 me-3">
            <div class="bg-white p-3 mt-3" style="border-radius: 12px;">
              <div class="col-sm-12 text-center">
                <div class="mt-5">
                  <span><img src="./assets/images/license_exp.svg" alt=""></span>
                </div>
                <div class="mt-5 mb-3">
                  <span class="empty-report-text">{{"DASHBOARD.LICENSEEXPIRED" | translate}}</span>
                </div>
                <button
                  [ngClass]="systemList[0]?.productLink == null ? 'q-invalid-button px-4 auto-btn fs-16' : 'submit-btn bg-orgclr auto-btn fs-16' "
                  (click)="openMyIndexRenewLicense(systemList[0])">
                  {{ 'DASHBOARD.RENEWNOW' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>

      </ng-container>



      <ng-container *ngIf="isYoutubeReports">


        <!-- Youtube Report starts here -->
        <div class="mt-3 bg-white p-3" style="border-radius: 12px;">
          <!-- Actual Report-->
          <ng-container *ngIf="isYoutubeUsageChart">
            <div class="col-sm-12 relative">
              <div class="border-bottom negative_padding">
                <div class=" mt-2 ms-4 text_20_600 ">
                  <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                        src="./assets/images/youtubeIcon.svg" alt=""></span>{{ "DASHBOARD.ATTEMPTOYOUTUBECAT" |
                    translate
                    }}</span>
                </div>
                <div class="mt-1 mb-3 ms-4 text_20_600 ">
                  <span> {{ totalYoutubeUsage }}</span>
                  <span class="ms-1">{{ "PARENTALREPORTS.ATTEMPTS" | translate }}<span class="ms-1"
                      style="font-weight: 400;font-size: 12px;">{{
                      "DASHBOARD.INLAST7DAYS" | translate }}</span> </span>
                </div>
                <!-- <div><a routerLink="/home/reports"><span
                      style="position:absolute;top: 4px;right: 24px;color: #F16522; text-decoration: underline;font-weight: 600;">{{
                      "MANAGEUSER.VIEWDETAILS" | translate
                      }} <img class="ms-1" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a></div> -->
              </div>
              <div class="chart-container mt-5 me-3">
                <canvas id="youtubeUsageGraph" width="400" height="180"></canvas>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!isYoutubeUsageChart && !youtubeToggle">
            <!-- Empty Report -->
            <div class="border-bottom negative_padding">
              <div class=" mt-2 ms-4 text_20_600 ">
                <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                      src="./assets/images/youtubeIcon.svg" alt=""></span>{{ "DASHBOARD.ATTEMPTOYOUTUBECAT" |
                  translate
                  }}</span>
              </div>
              <div class="mt-4 pt-2 ms-4 text_20_600 ">
              </div>
            </div>
            <div class="col-sm-12 relative text-center">
              <div class="mt-5">
                <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
              </div>
              <div class="mt-2 mb-5">
                <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!isYoutubeUsageChart && youtubeToggle">
            <!-- Youtube Report Toggle State -->
            <div class="border-bottom negative_padding">
              <div class=" mt-2 ms-4 text_20_600 ">
                <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                      src="./assets/images/youtubeIcon.svg" alt=""></span>{{ "DASHBOARD.ATTEMPTOYOUTUBECAT" |
                  translate
                  }}</span>
              </div>
              <div class="mt-4 pt-2 ms-4 text_20_600 ">
              </div>
            </div>
            <div class="col-sm-12 relative text-center">
              <div class="mt-4 pt-2 mb-1">
                <span><img src="./assets/images/enableToggle.svg" alt=""></span>
              </div>
              <div class="mt-2">
                <span class="empty-report-text">{{ "DASHBOARD.ENABLEYOUTUBE" | translate }}</span>
              </div>
              <div class="mb-5">
                <span> {{ "DASHBOARD.ENABLEONINDDEVICE" | translate }} </span>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- Youtube Device Dropdown -->
        <div class="mt-4">

          <div class="d-flex align-items-center gap-3">
            <span class="fw-bold" style="font-weight: 400; font-size: 18px;">
              {{ 'DASHBOARD.SELECTDEVICE' | translate }}
            </span>

            <div class="device-select-wrapper">

              <ng-select #youTubeReportDevices class="bg-transparent custom w-100" bindLabel="deviceName" bindValue="id"
                [clearable]="false" [searchable]="false" [(ngModel)]="deviceid"
                (ngModelChange)="getDevicesId($event, 'YOUTUBE')" *ngIf="devicesList?.length != 0">

                <ng-container *ngFor="let value of devicesList">
                  <ng-option *ngIf="value.deviceType === 'MOBILE'" [value]="value.id" title="{{ value.deviceName }}">

                    <span>
                      {{ value?.deviceName?.length > 30
                      ? value?.deviceName.slice(0, 30) + '...'
                      : value?.deviceName }}
                    </span>

                  </ng-option>
                </ng-container>

              </ng-select>

              <select class="w-100" [(ngModel)]="deviceid" (ngModelChange)="getDevicesId($event, 'YOUTUBE')"
                *ngIf="devicesList?.length == 0">

                <option value="" disabled>
                  {{ 'ACTIVITYHISTORY.NODEVICES' | translate }}
                </option>

              </select>

            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-md-12">
            <ng-container *ngIf="showPremium">
              <!-- Youtube Report Premium State -->
              <div class="mt-4 bg-white p-3" style="border-radius: 12px;">
                <div class="col-sm-12 relative">
                  <div class="mt-5 pt-3">
                    <div class="mb-3 text-center">
                      <div class="mt-2">
                        <span><img src="./assets/images/upgradeToPremium.svg" alt=""></span>
                      </div>
                      <div class="mt-2 pt-1 pb-1">
                        <span *ngIf="status === 'Free version'" class="empty-report-text">{{
                          "DASHBOARD.PREMIUMFEATUREUPGARDE" | translate }}</span>
                        <span *ngIf="status === 'LICENSE_EXPIRED'" class="empty-report-text"> {{
                          "DASHBOARD.PREMIUMFEATURERENEW" | translate }} </span>
                      </div>
                      <div class="mt-2 pt-1">
                        <button *ngIf="status === 'Free version'" (click)="navigateToRenew()"
                          class="submit-btn bg-orgclr py-2 px-4 add-device shadow-none">
                          {{ "LICENSESUMMARY.UPGRADE" | translate }}
                        </button>
                        <button *ngIf="status === 'LICENSE_EXPIRED'" (click)="navigateToRenew()"
                          class="submit-btn bg-orgclr py-2 px-4 add-device shadow-none">
                          {{ "LICENSESUMMARY.RENEW" | translate }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>

          <div class="col-md-6">
            <ng-container *ngIf="isBlockedVideoChart && !showPremium">
              <!-- Youtube Device wise Report Start here -->
              <div class="mt-3 bg-white p-3 border-radius-6">
                <div class="col-sm-12 relative">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 text_20_600 relative">
                      <span class="px-1" style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                            src="./assets/images/youtubeIcon.svg" alt=""></span>{{
                        "PARENTALREPORTS.ATTEMPTTOBLOCKEDVIDEOS" |
                        translate
                        }}</span>
                      <span class="cursor-pointer" style="position: absolute;right: 16px;"
                        (click)="openTable('blockedVideoReport')"><img src="./assets/images/tableIconOrg.svg"></span>
                    </div>
                    <div class="mb-3 ms-4 text_20_600 ">
                      <span> {{ totalVideoHits }} </span>
                      <span>{{ "PARENTALREPORTS.TOTALATTEMPTS" | translate }}<span class="ms-1"
                          style="font-weight: 400;font-size: 12px;">{{
                          "DASHBOARD.INLAST7DAYS" | translate }}</span> </span>
                    </div>
                  </div>
                  <div class="row pt-3">
                    <div class="col-md-5 mt-5 ms-3 mb-3 me-3">
                      <canvas id="blockedVideosChart" width="400" height="200"></canvas>
                    </div>
                    <div class="col-md-5 mt-5">
                      <div *ngIf="youtubeDevices[0] && videoCounts[0]">
                        <div class="mt-3"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/blueRoundIcon.svg" alt=""></span><span>{{
                            youtubeDevices[0]?.length > 20 ? youtubeDevices[0]?.slice(0,20) + "..." : youtubeDevices[0]
                            }}</span>&nbsp;<span class="text_14_600 ">{{ videoCounts[0] + "%" }}</span></div>
                      </div>
                      <div *ngIf="youtubeDevices[1] && videoCounts[1]">
                        <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/darkBlueRoundIcon.svg" alt=""></span><span>{{
                            youtubeDevices[1].length > 20 ? youtubeDevices[1].slice(0,20) + "..." : youtubeDevices[1]
                            }}</span>&nbsp;<span class="text_14_600 "> {{ videoCounts[1] + "%" }} </span></div>
                      </div>
                      <div *ngIf="youtubeDevices[2] && videoCounts[2]">
                        <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/pinkRoundIcon.svg" alt=""></span><span>{{ youtubeDevices[2].length
                            > 20 ? youtubeDevices[2].slice(0,20) + "..." : youtubeDevices[2]
                            }}</span>&nbsp;<span class="text_14_600 ">{{ videoCounts[2] + "%" }}</span></div>
                      </div>
                      <div *ngIf="youtubeDevices[3] && videoCounts[3]">
                        <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/voiletRoundIcon.svg" alt=""></span><span>{{
                            youtubeDevices[3].length > 20 ? youtubeDevices[3].slice(0,20) + "..." : youtubeDevices[3]
                            }}</span>&nbsp;<span class="text_14_600 "> {{ videoCounts[3] + "%" }} </span></div>
                      </div>
                      <div *ngIf="youtubeDevices[4] && videoCounts[4]">
                        <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/yellowRoundIcon.svg" alt=""></span><span>{{
                            youtubeDevices[4].length > 20 ? youtubeDevices[4].slice(0,20) + "..." : youtubeDevices[4]
                            }}</span>&nbsp;<span class="text_14_600 "> {{ videoCounts[4] + "%" }} </span></div>
                      </div>
                      <div *ngIf="youtubeDevices[5] && videoCounts[5]">
                        <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/redRoundIcon.svg" alt=""></span><span>{{ youtubeDevices[5].length
                            > 20 ? youtubeDevices[5].slice(0,20) + "..." : youtubeDevices[5]
                            }}</span>&nbsp;<span class="text_14_600 ">{{ videoCounts[5] + "%" }}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!isBlockedVideoChart && !showPremium && youTubeDeviceToggle">
              <!-- Empty State-->
              <div class="mt-3 bg-white p-3 border-radius-6">
                <div class="col-sm-12 relative">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 mb-4 pb-4 text_20_600 relative">
                      <span class="mb-4" style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                            src="./assets/images/youtubeIcon.svg" alt=""></span>{{
                        "PARENTALREPORTS.ATTEMPTTOBLOCKEDVIDEOS" |
                        translate
                        }}</span>
                    </div>
                    <div class="mt-3 mb-3 ms-4 text_20_600 ">
                    </div>
                  </div>
                  <div class="mb-2 text-center">
                    <div class="mt-5">
                      <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                    </div>
                    <div class="mt-2 mb-5">
                      <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!youTubeDeviceToggle && !isBlockedVideoChart && !showPremium">
              <!-- Toggle State-->
              <div class="mt-3 bg-white p-3 border-radius-6">
                <div class="col-sm-12 relative">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 mb-4 pb-4 text_20_600 relative">
                      <span class="mb-4" style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                            src="./assets/images/youtubeIcon.svg" alt=""></span>{{
                        "PARENTALREPORTS.ATTEMPTTOBLOCKEDVIDEOS" |
                        translate
                        }}</span>
                    </div>
                    <div class="mt-3 mb-3 ms-4 text_20_600 ">
                    </div>
                  </div>
                  <div class="mb-2 text-center">
                    <div class="mt-4 pt-3">
                      <span><img src="./assets/images/enableToggle.svg" alt=""></span>
                    </div>
                    <div class="mt-2">
                      <span class="empty-report-text">{{ "DASHBOARD.ENABLEYOUTUBE" | translate }}</span>
                    </div>
                    <div class="mt-2 mb-3 pb-2">
                      <span>{{ "DASHBOARD.ENABLEONINDDEVICE" | translate }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          <!--  Attempts to access blocked channels -->
          <div class="col-md-6">
            <ng-container *ngIf="isBlockedChannnelChart && !showPremium">
              <div class="mt-3 bg-white p-3 border-radius-6">
                <div class="col-sm-12 relative">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 text_20_600 relative">
                      <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                            src="./assets/images/youtubeIcon.svg" alt=""></span>{{
                        "PARENTALREPORTS.ATTEMPTTOBLOCKEDCHANNELS" |
                        translate
                        }}</span>
                      <span class="cursor-pointer" style="position: absolute;right: 16px;"
                        (click)="openTable('blockedChannelReport')"><img src="./assets/images/tableIconOrg.svg"></span>
                    </div>
                    <div class="mb-3 ms-4 text_20_600 ">
                      <span> {{ totalChannelCounts }} </span>
                      <span>{{ "PARENTALREPORTS.TOTALATTEMPTS" | translate }}<span class="ms-1"
                          style="font-weight: 400;font-size: 12px;">{{
                          "DASHBOARD.INLAST7DAYS" | translate }}</span> </span>
                    </div>
                  </div>
                  <div class="row pt-3">
                    <div class="col-md-5 mt-5 ms-3 mb-3 me-3">
                      <canvas id="blockedChannnelChart" width="400" height="200"></canvas>
                    </div>
                    <div class="col-md-5 mt-5">
                      <div *ngIf="channelList[0] && channelVistValue[0]">
                        <div class="mt-3"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/blueRoundIcon.svg" alt=""></span><span>{{
                            channelList[0].length > 20 ? channelList[0].slice(0,20) + "..." : channelList[0]
                            }}</span> &nbsp;<span class="text_14_600 ">{{ channelVistValue[0] + "%" }}</span></div>
                      </div>
                      <div *ngIf="channelList[1] && channelVistValue[1]">
                        <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/blueRoundIcon.svg" alt=""></span><span>{{
                            channelList[1].length > 20 ? channelList[1].slice(0,20) + "..." : channelList[1]
                            }}</span> &nbsp;<span class="text_14_600 ">{{ channelVistValue[1] + "%" }}</span></div>
                      </div>
                      <div *ngIf="channelList[2] && channelVistValue[2]">
                        <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/pinkRoundIcon.svg" alt=""></span><span>{{ channelList[2].length
                            > 20 ? channelList[2].slice(0,20) + "..." : channelList[2]
                            }}</span>&nbsp;<span class="text_14_600 ">{{ channelVistValue[2] + "%" }}</span></div>
                      </div>
                      <div *ngIf="channelList[3] && channelVistValue[3]">
                        <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/pinkRoundIcon.svg" alt=""></span><span>{{ channelList[3].length
                            > 20 ? channelList[2].slice(0,20) + "..." : channelList[3]
                            }}</span>&nbsp;<span class="text_14_600 ">{{ channelVistValue[3] + "%" }}</span></div>
                      </div>
                      <div *ngIf="channelList[4] && channelVistValue[4]">
                        <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/yellowRoundIcon.svg" alt=""></span><span>{{
                            channelList[4].length > 20 ? channelList[4].slice(0,20) + "..." : channelList[4]
                            }}</span>&nbsp;<span class="text_14_600 ">{{ channelVistValue[4] + "%" }}</span></div>
                      </div>
                      <div *ngIf="channelList[5] && channelVistValue[5]">
                        <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/yellowRoundIcon.svg" alt=""></span><span>{{
                            channelList[5].length > 20 ? channelList[5].slice(0,20) + "..." : channelList[5]
                            }}</span>&nbsp;<span class="text_14_600 ">{{ channelVistValue[5] + "%" }}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="!isBlockedChannnelChart && !showPremium && youTubeDeviceToggle">
              <!-- Empty State-->
              <div class="mt-3 bg-white p-3 border-radius-6">
                <div class="col-sm-12 relative">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 mb-4 pb-4 text_20_600 relative">
                      <span class="mb-4" style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                            src="./assets/images/youtubeIcon.svg" alt=""></span>{{
                        "PARENTALREPORTS.ATTEMPTTOBLOCKEDCHANNELS" |
                        translate
                        }}</span>
                    </div>
                    <div class="mt-3 mb-3 ms-4 text_20_600 ">
                    </div>
                  </div>
                  <div class="mb-2 text-center">
                    <div class="mt-5">
                      <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                    </div>
                    <div class="mt-2 mb-5">
                      <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!youTubeDeviceToggle && !isBlockedChannnelChart && !showPremium">
              <!-- Toggle State-->
              <div class="mt-3 bg-white p-3 border-radius-6">
                <div class="col-sm-12 relative">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 mb-4 pb-4 text_20_600 relative">
                      <span class="mb-4" style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                            src="./assets/images/youtubeIcon.svg" alt=""></span>{{
                        "PARENTALREPORTS.ATTEMPTTOBLOCKEDCHANNELS" |
                        translate
                        }}</span>
                    </div>
                    <div class="mt-3 mb-3 ms-4 text_20_600 ">
                    </div>
                  </div>
                  <div class="mb-2 text-center">
                    <div class="mt-4 pt-3">
                      <span><img src="./assets/images/enableToggle.svg" alt=""></span>
                    </div>
                    <div class="mt-2">
                      <span class="empty-report-text">{{ "DASHBOARD.ENABLEYOUTUBE" | translate }}</span>
                    </div>
                    <div class="mt-2 mb-3 pb-2">
                      <span>{{ "DASHBOARD.ENABLEONINDDEVICE" | translate }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="row mt-2">
          <!--  Video Category Visits -->
          <div class="col-md-6">
            <ng-container *ngIf="isVideoCatChart && !showPremium">
              <div class="mt-3 mb-5 bg-white p-3 border-radius-6">
                <div class="col-sm-12 relative">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 text_20_600 relative">
                      <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                            src="./assets/images/youtubeIcon.svg" alt=""></span>{{
                        "PARENTALREPORTS.VIDEOCATVISITS" |
                        translate
                        }}</span>
                      <span class="cursor-pointer" style="position: absolute;right: 16px;"
                        (click)="openTable('videoVisitReport')"><img src="./assets/images/tableIconOrg.svg"></span>
                    </div>
                    <div class="mb-3 ms-4 text_20_600 ">
                      <span> {{ totalVideoCatVisits }} </span>
                      <span>{{ "PARENTALREPORTS.VISITS" | translate }}<span class="ms-1"
                          style="font-weight: 400;font-size: 12px;">{{
                          "DASHBOARD.INLAST7DAYS" | translate }}</span> </span>
                    </div>
                  </div>
                  <div class="relative mt-3 mb-2">
                    <span class="ms-4" style="font-size: 14px;font-weight: 400;">{{ "PARENTALREPORTS.TOP5CAT" |
                      translate
                      }}</span>
                  </div>
                  <div>
                    <canvas id="videoCatVisitChart" width="400" height="240"></canvas>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="!isVideoCatChart && !showPremium && youTubeDeviceToggle">
              <!-- Empty State-->
              <div class="mt-3 mb-5 bg-white p-3 border-radius-6">
                <div class="col-sm-12 relative">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 mb-4 pb-4 text_20_600 relative">
                      <span class="mb-4" style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                            src="./assets/images/youtubeIcon.svg" alt=""></span>{{
                        "PARENTALREPORTS.VIDEOCATVISITS" |
                        translate
                        }}</span>
                    </div>
                    <div class="mt-3 mb-3 ms-4 text_20_600 ">
                    </div>
                  </div>
                  <div class="mb-2 text-center">
                    <div class="mt-5 pt-2">
                      <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                    </div>
                    <div class="mt-3 mb-4 pb-3">
                      <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!youTubeDeviceToggle && !isVideoCatChart && !showPremium">
              <!-- Toggle State-->
              <div class="mt-3 mb-5 bg-white p-3 border-radius-6">
                <div class="col-sm-12 relative">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 mb-4 pb-4 text_20_600 relative">
                      <span class="mb-4" style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                            src="./assets/images/youtubeIcon.svg" alt=""></span>{{
                        "PARENTALREPORTS.VIDEOCATVISITS" |
                        translate
                        }}</span>
                    </div>
                    <div class="mt-3 mb-3 ms-4 text_20_600 ">
                    </div>
                  </div>
                  <div class="mb-2 text-center">
                    <div class="mt-5 pt-2">
                      <span><img src="./assets/images/enableToggle.svg" alt=""></span>
                    </div>
                    <div class="mt-2">
                      <span class="empty-report-text">{{ "DASHBOARD.ENABLEYOUTUBE" | translate }}</span>
                    </div>
                    <div class="mt-2 mb-3">
                      <span>{{ "DASHBOARD.ENABLEONINDDEVICE" | translate }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>

          <!--  Channel Visits -->
          <div class="col-md-6">
            <ng-container *ngIf="isChannelVisitChart && !showPremium">
              <div class="mt-3 bg-white p-3 border-radius-6">
                <div class="col-sm-12 relative">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 text_20_600 relative">
                      <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                            src="./assets/images/youtubeIcon.svg" alt=""></span>{{
                        "PARENTALREPORTS.CHANNELVISITS" |
                        translate
                        }}</span>
                      <span class="cursor-pointer" style="position: absolute;right: 16px;"
                        (click)="openTable('channelVisitReport')"><img src="./assets/images/tableIconOrg.svg"></span>
                    </div>
                    <div class="mb-3 ms-4 text_20_600 ">
                      <span> {{ toatlChannelVisits }} </span>
                      <span>{{ "PARENTALREPORTS.VISITS" | translate }}<span class="ms-1"
                          style="font-weight: 400;font-size: 12px;">{{
                          "DASHBOARD.INLAST7DAYS" | translate }}</span> </span>
                    </div>
                  </div>
                  <div class="relative mt-3 mb-2">
                    <span class="ms-4" style="font-size: 14px;font-weight: 400;">{{ "PARENTALREPORTS.TOP5CHANNELS" |
                      translate
                      }}</span>
                  </div>
                  <div>
                    <canvas id="channelVisitChart" width="400" height="240"></canvas>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!isChannelVisitChart && !showPremium && youTubeDeviceToggle">
              <!-- Empty State-->
              <div class="mt-3 bg-white p-3 border-radius-6">
                <div class="col-sm-12 relative">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 mb-4 pb-4 text_20_600 relative">
                      <span class="mb-4" style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                            src="./assets/images/youtubeIcon.svg" alt=""></span>{{
                        "PARENTALREPORTS.CHANNELVISITS" |
                        translate
                        }}</span>
                    </div>
                    <div class="mt-3 mb-3 ms-4 text_20_600 ">
                    </div>
                  </div>
                  <div class="mb-2 text-center">
                    <div class="mt-5 pt-2">
                      <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                    </div>
                    <div class="mt-3 mb-4 pt-3">
                      <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!youTubeDeviceToggle && !isChannelVisitChart && !showPremium">
              <!-- Toggle State-->
              <div class="mt-3 bg-white p-3 border-radius-6">
                <div class="col-sm-12 relative">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 mb-4 pb-4 text_20_600 relative">
                      <span class="mb-4" style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                            src="./assets/images/youtubeIcon.svg" alt=""></span>{{
                        "PARENTALREPORTS.CHANNELVISITS" |
                        translate
                        }}</span>
                    </div>
                    <div class="mt-3 mb-3 ms-4 text_20_600 ">
                    </div>
                  </div>
                  <div class="mb-2 text-center">
                    <div class="mt-5 pt-2">
                      <span><img src="./assets/images/enableToggle.svg" alt=""></span>
                    </div>
                    <div class="mt-2">
                      <span class="empty-report-text">{{ "DASHBOARD.ENABLEYOUTUBE" | translate }}</span>
                    </div>
                    <div class="mt-2 mb-3">
                      <span>{{ "DASHBOARD.ENABLEONINDDEVICE" | translate }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      <ng-container *ngIf="isAntiTrackerReport">
        <div class="p-1">
          <div class="mt-3 bg-white p-3 border-radius-12" *ngIf="antiTrackerDeviceCnt < 1">
            <div class="col-sm-12">
              <div class="border-bottom negative_padding">
                <div class=" mt-2 ms-4 text_20_600 ">
                  <span class="font-18 font-weight-400"><span><img class="pb-1"
                        src="./assets/images/Blocked_eye_icon.svg" alt=""></span>{{"REPORTS.TRACKERSBLOCKED" |
                    translate}}</span>
                </div>
                <div class="mb-3 ms-3 text_20_600 ">
                </div>
              </div>
              <div class="col-sm-12 text-center">
                <div class="mt-5">
                  <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                </div>
                <div class="mt-2 mb-5">
                  <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-3 bg-white p-3 border-radius-6" *ngIf="antiTrackerDeviceCnt > 0">
            <div class="col-sm-12 relative">
              <div class="border-bottom negative_padding">
                <div class=" mt-2 ms-4 text_20_600 ">
                  <span class="font-18 font-weight-400"><span><img class="pb-1"
                        src="./assets/images/Blocked_eye_icon.svg" alt=""></span>{{"REPORTS.TRACKERSBLOCKED" |
                    translate}}</span>
                </div>
                <div class="mb-3 ms-3 text_20_600 ">
                  <span class="ms-2">{{ antiTrackersBlockedCnt }} </span>
                  <span>{{"REPORTS.BLOCKED" | translate}} </span>
                  <span class="last7-dashboard ">
                    {{ "DASHBOARD.INLAST7DAYS" | translate }}
                  </span>
                </div>
              </div>
              <div class="relative">
              </div>
              <div class="chart-container mt-5">
                <canvas id="userWiseAntiTrackerReport" width="400" height="200"></canvas>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4 mb-0" *ngIf="systemList?.length > 0">
          <!-- Screentime Device Dropdown -->
          <div class="mt-4">

            <div class="d-flex align-items-center gap-3">
              <span class="fw-bold font-18">
                {{ 'DASHBOARD.SELECTDEVICE' | translate }}
              </span>

              <div class="device-select-wrapper">

                <ng-select #antiTrackerSystem class="bg-transparent custom w-100" bindLabel="deviceName" bindValue="id"
                  [clearable]="false" [searchable]="false" [(ngModel)]="systemId" [items]="systemList"
                  (ngModelChange)="getDesktopAntiTrackerReport($event)">

                  <ng-template ng-label-tmp let-item="item">
                    <span>
                      {{ item?.deviceName?.length > 30
                      ? item?.deviceName.slice(0, 30) + '...'
                      : item?.deviceName }}
                    </span>
                  </ng-template>

                  <ng-template ng-option-tmp let-item="item">
                    <span title="{{ item?.deviceName }}">
                      {{ item?.deviceName.length > 30
                      ? item?.deviceName.slice(0, 30) + '...'
                      : item?.deviceName }}
                    </span>
                  </ng-template>

                </ng-select>

              </div>
            </div>

          </div>

          <div class="p-1">
            <div class="mt-3 bg-white p-3 border-radius-12" *ngIf="antiTrackerReportCnt < 1">
              <div class="border-bottom negative_padding">
                <div class=" mt-2 ms-4 text_20_600 ">
                  <span class="font-18 font-weight-400"><span><img class="pb-1"
                        src="./assets/images/Blocked_eye_icon.svg" alt=""></span>{{"REPORTS.TRACKERSBLOCKED" |
                    translate}}</span>
                </div>
                <div class="mb-3 ms-3 text_20_600 ">
                </div>
              </div>
              <div class="col-sm-12 text-center">
                <div class="mt-5">
                  <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                </div>
                <div class="mt-2 mb-5">
                  <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                </div>
              </div>
            </div>
            <div class="my-3 bg-white p-3 border-radius-6" *ngIf="antiTrackerReportCnt > 0">
              <div class="col-sm-12 relative">
                <div class="border-bottom negative_padding">
                  <div class=" mt-2 ms-4 text_20_600 ">
                    <span class="font-18 font-weight-400"><span><img class="pb-1"
                          src="./assets/images/Blocked_eye_icon.svg" alt=""></span>{{"REPORTS.TRACKERSBLOCKED" |
                      translate}}</span>
                  </div>
                  <div class="mb-3 ms-3 text_20_600 ">
                    <span class="ms-2">{{ antiTrackerDeviceWiseReportCnt }} </span>
                    <span>{{"REPORTS.BLOCKED" | translate}} </span>
                    <span class="last7-dashboard ">
                      {{ "DASHBOARD.INLAST7DAYS" | translate }}
                    </span>
                  </div>
                </div>
                <div class="relative">
                </div>
                <div class="chart-container">
                  <canvas id="systemWiseAntiTrackerReport" height="250"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isScreentimeMonitoring && isGraphView">
        <div class="p-1">
          <!-- Screentime Empty Report Devicewise-->
          <div class="mt-3 bg-white p-3" style="border-radius: 12px;" *ngIf="noOfDeviceData < 1 && screenToggle">
            <div class="border-bottom negative_padding">
              <div class=" mt-2 ms-4 text_20_600 ">
                <span style="font-weight: 400;font-size: 18px;"><span><img class="pb-1"
                      src="./assets/images/TimeclockTime.svg" alt=""></span>{{"DASHBOARD.YESTERDAYSCREENTIME" |
                  translate}}</span>
              </div>
              <div class="mb-3 ms-3 text_20_600 ">
                <span class="ms-2"></span>
              </div>
            </div>
            <div class="col-sm-12 text-center">
              <div class="mt-5">
                <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
              </div>
              <div class="mt-2 mb-5">
                <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
              </div>
            </div>
          </div>
          <!-- Enable Screen Time to generate reports-->
          <div class="mt-3 bg-white p-3" style="border-radius: 12px;" *ngIf="noOfDeviceData < 1 && !screenToggle">
            <div class="col-sm-12 text-center">
              <div class="mt-5">
                <span><img src="./assets/images/enableToggle.svg" alt=""></span>
              </div>
              <div class="mt-2 mb-2">
                <span class="empty-report-text">{{ "DASHBOARD.ENABLESCREENTIME" | translate }}</span>
              </div>
              <div class="mb-5">
                <span> {{ "DASHBOARD.ENABLEONINDDEVICE" | translate }} </span>
              </div>
            </div>
          </div>
          <!-- Actual ScreenTime Report-->
          <div class="mt-3 bg-white p-3 border-radius-12" *ngIf="noOfDeviceData > 0">
            <div class="col-sm-12 relative">
              <div class="border-bottom negative_padding">
                <div class=" mt-2 ms-4 text_20_600 ">
                  <span style="font-weight: 400;font-size: 18px;"><span><img class="pb-1"
                        src="./assets/images/TimeclockTime.svg" alt=""></span>{{"DASHBOARD.YESTERDAYSCREENTIME" |
                    translate}}</span>
                </div>
                <div class="mb-3 ms-3 text_20_600 ">
                  <span class="ms-2">
                    {{ totalHours }}{{ 'PARENTALREPORTS.HNOT' | translate }}
                    {{ totalMin }}{{ 'PARENTALREPORTS.MNOT' | translate }}
                  </span>
                </div>
              </div>
              <div class="relative">
                <div style="position: absolute;top: 12px; right: 32px;">
                  <span class="me-2"><img class="me-1" src="./assets/images/RecommdLine.svg"
                      alt="">{{"DASHBOARD.RECOMMEND"
                    |
                    translate}} {{ "( 4h 0m)" }}</span>
                  <span class="me-1"><img class="me-1 pb-1" src="./assets/images/underLimitIcon.svg"
                      alt="">{{"PARENTALREPORTS.UNDERUTILIZED" | translate}} </span>
                  <span class="me-1"><img class="me-1 pb-1" src="./assets/images/overLimitIcon.svg"
                      alt="">{{"PARENTALREPORTS.OVERUTILIZED" | translate}} </span>
                </div>
              </div>
              <div class="chart-container mt-5">
                <canvas id="deviceWiseScreentime" width="400" height="200"></canvas>
              </div>
            </div>
          </div>
        </div>

        <div class="p-1" id="screentimeReportRow">
          <div class="row mb-5">
            <div class="mt-3 mb-0" *ngIf="isScreentimeMonitoring && isGraphView">

              <!-- Screentime Device Dropdown -->
              <div class="mt-4">

                <div class="d-flex align-items-center gap-3">
                  <span class="fw-bold" style="font-weight: 400; font-size: 18px;">
                    {{ 'DASHBOARD.SELECTDEVICE' | translate }}
                  </span>

                  <div class="device-select-wrapper">

                    <ng-select #screenTimeReportDevices class="bg-transparent custom w-100" bindLabel="deviceName"
                      bindValue="id" [clearable]="false" [searchable]="false" [(ngModel)]="deviceid"
                      [items]="devicesList" (ngModelChange)="getDevicesId($event, 'SCREEN')"
                      *ngIf="devicesList?.length != 0">

                      <ng-template ng-label-tmp let-item="item">
                        <span>
                          {{ item?.deviceName?.length > 30
                          ? item?.deviceName.slice(0, 30) + '...'
                          : item?.deviceName }}
                        </span>
                      </ng-template>

                      <ng-template ng-option-tmp let-item="item">
                        <span title="{{ item?.deviceName }}">
                          {{ item?.deviceName.length > 30
                          ? item?.deviceName.slice(0, 30) + '...'
                          : item?.deviceName }}
                        </span>
                      </ng-template>

                    </ng-select>

                    <select class="w-100" [(ngModel)]="deviceid" (ngModelChange)="getDevicesId($event, 'SCREEN')"
                      *ngIf="devicesList?.length == 0">

                      <option value="" disabled>
                        {{ 'ACTIVITYHISTORY.NODEVICES' | translate }}
                      </option>

                    </select>

                  </div>
                </div>

              </div>
            </div>

            <div class="col-md-6">
              <!-- Weekly screen time limit  -->
              <div class="mt-3 bg-white p-3 border-radius-6"
                *ngIf="isScreentimeMonitoring && isGraphView && showWeeklyST">
                <div class="border-bottom negative_padding">
                  <div class=" mt-2 ms-4 text_20_600 ">
                    <span style="font-weight: 400;font-size: 18px;"><span><img class="pb-1 me-1"
                          src="./assets/images/TimeclockTime.svg" alt=""></span>{{
                      "PARENTALREPORTS.WEEKLYSCREENTIMELIMIT" |
                      translate }}</span>
                  </div>
                  <div class="mb-3 ms-3 text_20_600 ">
                    <span class="ms-2">
                      {{ weeklyScreenHour }}{{ 'PARENTALREPORTS.HNOT' | translate }}
                      {{ weeklyScreenMins }}{{ 'PARENTALREPORTS.MNOT' | translate }}
                      <span style="font-weight: 400;font-size: 12px;">{{
                        "DASHBOARD.INLAST7DAYS" | translate }}</span></span>
                  </div>
                </div>
                <div class="relative mt-3 mb-5">
                  <span style="position: absolute;top: 0px; right: 32px;"><span class="me-2"><img class="me-1"
                        src="./assets/images/RecommdLine.svg" alt="">{{"DASHBOARD.RECOMMEND" |
                      translate}} {{ "( 4h 0m)" }}</span>
                    <span class="me-1"><img class="me-1 pb-1" src="./assets/images/underLimitIcon.svg"
                        alt="">{{"PARENTALREPORTS.UNDERUTILIZED" | translate}} </span>
                    <span class="me-1"><img class="me-1 pb-1" src="./assets/images/overLimitIcon.svg"
                        alt="">{{"PARENTALREPORTS.OVERUTILIZED" | translate}} </span>
                  </span>
                </div>
                <div class="mb-2">
                  <canvas id="myChartWeeklyLimitScreenTimeControl" width="470" height="200"></canvas>
                </div>
              </div>
              <!-- Weekly screen time limit Empty State -->
              <div class="mt-3 bg-white p-3 border-radius-6"
                *ngIf="isScreentimeMonitoring && isGraphView && !showWeeklyST && screenDeviceToggle">
                <div class="border-bottom negative-padding">
                  <div class=" mt-2 ms-4 text_20_600 mb-5">
                    <span style="font-weight: 400;font-size: 18px;"><span><img class="pb-1 me-1"
                          src="./assets/images/TimeclockTime.svg" alt=""></span>{{
                      "PARENTALREPORTS.WEEKLYSCREENTIMELIMIT" |
                      translate }}</span>
                  </div>
                </div>
                <div class="mb-2 text-center">
                  <div class="mt-4 pt-3">
                    <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                  </div>
                  <div class="mt-3 mb-4">
                    <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                  </div>
                </div>
              </div>
              <!-- Weekly screen time limit toggle case-->
              <div class="mt-3 bg-white p-3 border-radius-6"
                *ngIf="isScreentimeMonitoring && isGraphView && !showWeeklyST && !screenDeviceToggle">
                <div class="border-bottom negative-padding">
                  <div class=" mt-2 ms-4 text_20_600 mb-5">
                    <span style="font-weight: 400;font-size: 18px;"><span><img class="pb-1 me-1"
                          src="./assets/images/TimeclockTime.svg" alt=""></span>{{
                      "PARENTALREPORTS.WEEKLYSCREENTIMELIMIT" |
                      translate }}</span>
                  </div>
                </div>
                <div class="mb-2 text-center">
                  <div class="mt-3">
                    <span><img src="./assets/images/enableToggle.svg" alt=""></span>
                  </div>
                  <div class="mt-3 mb-2">
                    <span class="empty-report-text">{{ "DASHBOARD.ENABLESCREENTIME" | translate }}</span>
                  </div>
                  <div class="mb-3">
                    <span> {{ "DASHBOARD.ENABLEONINDDEVICE" | translate }} </span>
                  </div>
                </div>
              </div>
              <!-- Weekly app category usage actual Report-->
              <div class="mt-4 p-2 bg-white border-radius-6" *ngIf="isScreentimeMonitoring && deviceType ==='MOBILE'">
                <div *ngIf="showAppCatChart">
                  <div class="mt-3 bg-white p-0 border-radius-6">
                    <div class="border-bottom negative-padding">
                      <div class=" mt-2 ms-4 text_20_600 ">
                        <span style="font-weight: 400;font-size: 18px;"><span><img class="pb-1 me-1"
                              src="./assets/images/TimeclockTime.svg" alt=""></span>{{
                          "PARENTALREPORTS.WEEKLYAPPCATEGORYUSAGE" |
                          translate }}</span>
                      </div>
                      <div class="mb-3 ms-3 text_20_600 ">
                        <span class="ms-2">{{ totalCatScreentime }} <span style="font-weight: 400;font-size: 12px;">{{
                            "DASHBOARD.INLAST7DAYS" | translate }}</span></span>
                      </div>
                    </div>
                    <div class="relative mt-3 mb-1 d-flex justify-content-sm-between">
                      <div class="ms-4 d-flex" style="font-size: 14px;font-weight: 400;">{{
                        "PARENTALREPORTS.TOP3CATEGORY" |
                        translate
                        }}</div>
                      <div class="d-flex"><span *ngIf="keysList[0]" class=" me-2"><img class="me-1"
                            src="./assets/images/blueFirstCat.svg" alt=""> {{
                          keysList[0].length > 8 ?
                          keysList[0].slice(0,6)+ "..." : keysList[0] }}</span>
                        <span class="me-2" *ngIf="keysList[1]"><img class="me-1" src="./assets/images/skySecondCat.svg"
                            alt="">{{
                          keysList[1].length > 8 ? keysList[1].slice(0,6)+ "..." : keysList[1] }}</span><span
                          *ngIf="keysList[2]"><img class="me-1" src="./assets/images/yellowCat.svg" alt="">{{
                          keysList[2].length > 8 ? keysList[2].slice(0,6)+ "..." : keysList[2] }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="mt-0 mb-0">
                    <canvas id="catWiseScreentime" width="470" height="230"></canvas>
                  </div>
                </div>
                <!-- Weekly app category usage Empty State-->
                <div *ngIf="!showAppCatChart && screenDeviceToggle">
                  <div class="border-bottom negative-padding mb-2">
                    <div class=" mt-3 ms-4 text_20_600 mb-5">
                      <span style="font-weight: 400;font-size: 18px;"><span><img class="pb-1 me-1"
                            src="./assets/images/TimeclockTime.svg" alt=""></span>{{
                        "PARENTALREPORTS.WEEKLYAPPCATEGORYUSAGE" |
                        translate }}</span>
                    </div>
                  </div>
                  <div class="mb-3 text-center">
                    <div class="mt-5">
                      <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                    </div>
                    <div class="mt-3 mb-4 pb-2">
                      <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                    </div>
                  </div>
                </div>
                <!-- Weekly app category usage Toggle State-->
                <div class="p-1" *ngIf="!showAppCatChart && !screenDeviceToggle">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 text_20_600 mb-5">
                      <span style="font-weight: 400;font-size: 18px;"><span><img class="pb-1 me-1"
                            src="./assets/images/TimeclockTime.svg" alt=""></span>{{
                        "PARENTALREPORTS.WEEKLYAPPCATEGORYUSAGE" |
                        translate }}</span>
                    </div>
                  </div>
                  <div class="mb-2 text-center">
                    <div class="mt-4 pt-2">
                      <span><img src="./assets/images/enableToggle.svg" alt=""></span>
                    </div>
                    <div class="mt-3 mb-2">
                      <span class="empty-report-text">{{ "DASHBOARD.ENABLESCREENTIME" | translate }}</span>
                    </div>
                    <div class="mb-3">
                      <span> {{ "DASHBOARD.ENABLEONINDDEVICE" | translate }} </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <ng-container *ngIf="isScreentimeMonitoring && deviceType === 'MOBILE'">
                <!-- Daily app limit Actual Report -->
                <div class="mt-3 bg-white p-3 border-radius-6" *ngIf="showDailyAppChart">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 text_20_600 ">
                      <span style="font-weight: 400;font-size: 18px;"><span><img class="pb-1 me-1"
                            src="./assets/images/TimeclockTime.svg" alt=""></span>{{ "PARENTALREPORTS.DAILYAPPLIMIT" |
                        translate }}</span>
                    </div>
                    <div class="mb-3 ms-3 text_20_600 ">
                      <span class="ms-2">
                        {{ dailyAppTH }}{{ 'PARENTALREPORTS.HNOT' | translate }}
                        {{ dailyAppTM }}{{ 'PARENTALREPORTS.MNOT' | translate }}
                      </span>
                    </div>
                  </div>
                  <div class="relative mt-3">
                    <span class="ms-4" style="font-size: 14px;font-weight: 400;">{{ "PARENTALREPORTS.TOP5APP" |
                      translate
                      }}</span>
                  </div>
                  <div class="screenTimeChartDiv">
                    <canvas id="myChartWeekScreenTimeControl" width="470" height="240"></canvas>
                  </div>
                </div>
                <!-- Daily app limit Empty State Report -->
                <div class="mt-3 bg-white p-3 border-radius-6" *ngIf="!showDailyAppChart && screenDeviceToggle">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 text_20_600 mb-5">
                      <span style="font-weight: 400;font-size: 18px;"><span><img class="pb-1 me-1"
                            src="./assets/images/TimeclockTime.svg" alt=""></span>{{ "PARENTALREPORTS.DAILYAPPLIMIT" |
                        translate }}</span>
                    </div>
                  </div>
                  <div class="mb-2 text-center">
                    <div class="mt-4 pt-3">
                      <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                    </div>
                    <div class="mt-3 mb-4">
                      <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                    </div>
                  </div>
                </div>
                <!-- Daily app limit Toggle State Report -->
                <div class="mt-3 bg-white p-3 border-radius-6" *ngIf="!showDailyAppChart && !screenDeviceToggle">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 text_20_600 mb-5">
                      <span style="font-weight: 400;font-size: 18px;"><span><img class="pb-1 me-1"
                            src="./assets/images/TimeclockTime.svg" alt=""></span>{{
                        "PARENTALREPORTS.DAILYAPPLIMIT" |
                        translate }}</span>
                    </div>
                  </div>
                  <div class="mb-2 text-center">
                    <div class="mt-3">
                      <span><img src="./assets/images/enableToggle.svg" alt=""></span>
                    </div>
                    <div class="mt-3 mb-2">
                      <span class="empty-report-text">{{ "DASHBOARD.ENABLESCREENTIME" | translate }}</span>
                    </div>
                    <div class="mb-3">
                      <span> {{ "DASHBOARD.ENABLEONINDDEVICE" | translate }} </span>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="isScreentimeMonitoring && deviceType === 'MOBILE'">
                <!-- Weekly app usage Actual Report-->
                <div class="mt-4 bg-white p-3 border-radius-6" *ngIf="showScreentimeDonut">
                  <div class="border-bottom negative_padding mb-2">
                    <div class=" mt-2 ms-4 text_20_600 relative">
                      <span style="font-weight: 400;font-size: 18px;"><span><img class="pb-1 me-1"
                            src="./assets/images/TimeclockTime.svg" alt=""></span>{{ "PARENTALREPORTS.WEEKLYAPPUSAGE"
                        |
                        translate }}</span>
                      <span class="cursor-pointer" style="position: absolute;right: 16px;"
                        (click)="openWeeklyAppUsageTable()"><img src="./assets/images/tableIconOrg.svg"></span>
                    </div>
                    <div class="mb-3 ms-4 text_20_600 ">
                      <span class="me-1 ms-0">
                        {{ weeklyScreenHour }}{{ 'PARENTALREPORTS.HNOT' | translate }}
                        {{ weeklyScreenMins }}{{ 'PARENTALREPORTS.MNOT' | translate }}
                      </span>
                      <span style="font-weight: 400;font-size: 12px;">{{ "DASHBOARD.INLAST7DAYS" | translate }}</span>
                    </div>
                  </div>
                  <!-- <div class="relative mt-3">
                <span class="ms-4" style="font-size: 14px;font-weight: 400;">{{ "PARENTALREPORTS.TOP5APP" |
                  translate
                  }}</span>
              </div> -->
                  <!-- <div id="" class=""> -->
                  <div class="row mt-5 mb-2">
                    <div class="col-md-5 ms-3 mb-2 me-3">
                      <canvas id="screentimeDougnut" width="400" height="200"></canvas>
                    </div>
                    <div class="col-md-5 mt-3 pt-1">
                      <div *ngIf="screenDonutApps[0] && screenDonutPercentage[0]">
                        <div class="mt-0"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/blueRoundIcon.svg" alt=""></span><span>{{
                            screenDonutApps[0].length > 20 ? screenDonutApps[0].slice(0,20)+"...":
                            screenDonutApps[0] }}&nbsp;<span class="text_14_600 ">{{ screenDonutPercentage[0] + "%"
                              }}</span></span>
                        </div>
                      </div>
                      <div *ngIf="screenDonutApps[1] && screenDonutPercentage[1]">
                        <div *ngIf="screenDonutApps[1] && screenDonutPercentage[1]" class="mt-1"><span class="me-1"><img
                              class="pb-1 me-1" src="./assets/images/darkBlueRoundIcon.svg" alt=""></span><span>{{
                            screenDonutApps[1].length > 20 ? screenDonutApps[1].slice(0,30) + "..." :
                            screenDonutApps[1]
                            }}&nbsp;<span class="text_14_600 ">{{ screenDonutPercentage[1] + "%" }}</span></span>
                        </div>
                      </div>
                      <div *ngIf="screenDonutApps[2] && screenDonutPercentage[2]">
                        <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/pinkRoundIcon.svg" alt=""></span><span>{{
                            screenDonutApps[2].length
                            > 20 ? screenDonutApps[2].slice(0,20) + "..." : screenDonutApps[2]
                            }}&nbsp;<span class="text_14_600 ">{{ screenDonutPercentage[2] + "%" }}</span></span>
                        </div>
                      </div>
                      <div *ngIf="screenDonutApps[3] && screenDonutPercentage[3]">
                        <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/voiletRoundIcon.svg" alt=""></span><span>{{
                            screenDonutApps[3].length > 20 ? screenDonutApps[3].slice(0,20) + "..." :
                            screenDonutApps[3]
                            }}&nbsp;<span class="text_14_600 ">{{ screenDonutPercentage[3] + "%" }}</span></span>
                        </div>
                      </div>
                      <div *ngIf="screenDonutApps[4] && screenDonutPercentage[4]">
                        <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/yellowRoundIcon.svg" alt=""></span><span>{{
                            screenDonutApps[4].length > 20 ? screenDonutApps[4].slice(0,20) + "..." :
                            screenDonutApps[4]
                            }}&nbsp;<span class="text_14_600 ">{{ screenDonutPercentage[4] + "%" }}</span></span>
                        </div>
                      </div>
                      <div *ngIf="screenDonutApps[5] && screenDonutPercentage[5]">
                        <div class="mt-1"><span class="me-1"><img class="pb-1 me-1"
                              src="./assets/images/redRoundIcon.svg" alt=""></span><span>{{
                            screenDonutApps[5].length
                            > 20 ? screenDonutApps[5].slice(0,20) + "..." : screenDonutApps[5]
                            }}&nbsp;<span class="text_14_600 ">{{ screenDonutPercentage[5] + "%" }}</span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Weekly app usage Empty State Report-->
                <div class="mt-4 bg-white p-3 border-radius-6" *ngIf="!showScreentimeDonut && screenDeviceToggle">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 text_20_600 relative mb-5">
                      <span style="font-weight: 400;font-size: 18px;"><span><img class="pb-1 me-1"
                            src="./assets/images/TimeclockTime.svg" alt=""></span>{{ "PARENTALREPORTS.WEEKLYAPPUSAGE" |
                        translate }}</span>
                    </div>
                  </div>
                  <div class="mb-2 text-center">
                    <div class="mt-5">
                      <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                    </div>
                    <div class="mt-3 mb-4">
                      <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                    </div>
                  </div>
                </div>
                <!-- Weekly app usage Toggle State Report -->
                <div class="mt-4 bg-white p-3 border-radius-6" *ngIf="!showScreentimeDonut && !screenDeviceToggle">
                  <div class="border-bottom negative_padding">
                    <div class=" mt-2 ms-4 text_20_600 mb-5">
                      <span style="font-weight: 400;font-size: 18px;"><span><img class="pb-1 me-1"
                            src="./assets/images/TimeclockTime.svg" alt=""></span>{{
                        "PARENTALREPORTS.WEEKLYAPPUSAGE" |
                        translate }}</span>
                    </div>
                  </div>
                  <div class="mb-2 text-center">
                    <div class="mt-4 pt-2">
                      <span><img src="./assets/images/enableToggle.svg" alt=""></span>
                    </div>
                    <div class="mt-3 mb-2">
                      <span class="empty-report-text">{{ "DASHBOARD.ENABLESCREENTIME" | translate }}</span>
                    </div>
                    <div class="mb-2">
                      <span> {{ "DASHBOARD.ENABLEONINDDEVICE" | translate }} </span>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isIdsIpsReport">

        <div class="mb-3">
          <div class="mt-4 mb-0">

            <!-- IDS / IPS Protection Device Dropdown -->
            <div class="mt-4">

              <div class="d-flex align-items-center gap-3">
                <span class="fw-bold" style="font-weight: 400; font-size: 18px;">
                  {{ 'DASHBOARD.SELECTDEVICE' | translate }}
                </span>

                <div class="device-select-wrapper">

                  <ng-select #antiTrackerSystem class="bg-transparent custom w-100" bindLabel="deviceName"
                    bindValue="id" [clearable]="false" [searchable]="false" [(ngModel)]="systemId" [items]="systemList"
                    (ngModelChange)="idsIpsTableData($event)">

                    <ng-template ng-label-tmp let-item="item">
                      <span>
                        {{ item?.deviceName?.length > 30
                        ? item?.deviceName.slice(0, 30) + '...'
                        : item?.deviceName }}
                      </span>
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item">
                      <span title="{{ item?.deviceName }}">
                        {{ item?.deviceName.length > 30
                        ? item?.deviceName.slice(0, 30) + '...'
                        : item?.deviceName }}
                      </span>
                    </ng-template>

                  </ng-select>

                  <select class="w-100" [(ngModel)]="deviceid" (ngModelChange)="getDevicesId($event, 'IDSIPS')"
                    *ngIf="devicesList?.length == 0">

                    <option value="" disabled>
                      {{ 'ACTIVITYHISTORY.NODEVICES' | translate }}
                    </option>

                  </select>

                </div>
              </div>

            </div>
          </div>
        </div>


        <div class="mt-3 bg-white p-3" style="border-radius: 12px;"
          *ngIf="idsIpsReport?.length != 0 && selectedSystem?.expirydays > 0">
          <div class="bg-white h-100 p-sm-3 pt-1 me-3">
            <div class="border-bottom negative_padding-threat-table ">
              <div class=" mt-0 ms-3 text_20_600 ">
                <span style="font-weight: 400;font-size: 18px;"><span><img class="me-1 ms-2"
                      src="./assets/images/ids-ips-report-logo.svg" alt="" style="width: 22px; height: 22px;"></span>{{
                  "DASHBOARD.IDSIPS" | translate }}</span>

                <div class="mb-3 ms-3 text_20_600 ">
                  <span style="font-weight: 600;font-size: 12px;"><span><strong
                        style="font-size: 18px;">{{idsIpsReport?.length}}</strong><strong> {{"PARENTALREPORTS.ACTIVE" |
                        translate}} </strong> </span>{{
                    "DASHBOARD.INLAST7DAYS" | translate }}
                  </span>
                </div>
              </div>
            </div>

            <!-- <div class="scroller-threattableIdsIps px-0 mt-4" style="overflow-x: hidden;"> -->
            <div class="scroller-threattableIdsIps px-0 mt-4" style="overflow-y: auto; position: relative; z-index: 0;">
              <table class="table reports-table act-history mb-0 h-90" aria-describedby="Web Report Usage"
                id="qh-virus-table" style="width: 100%; table-layout: auto;">
                <thead class="activity-header border-radius-4 fixedTableHeaderIdsIps"
                  style="font-size: 16px; border-style: hidden;">
                  <tr style="border-style: hidden">
                    <th style="font-size: 16px; padding: 0 10px;">
                      <p class="mb-0 virusName">{{ "PARENTALREPORTS.DATE" | translate }}</p>
                    </th>
                    <th style="font-size: 16px; padding: 0 10px;">
                      <p class="mb-0 virusName">{{ "PARENTALREPORTS.VIRUSDATABASE" | translate }}</p>
                    </th>
                    <th style="font-size: 16px; padding: 0 10px;">
                      <p class="mb-0 virusName">{{ "PARENTALREPORTS.VulnerabilityDetected" | translate }}</p>
                    </th>
                    <th style="font-size: 16px; padding: 0 10px;">
                      <p class="mb-0 virusName">{{ "PARENTALREPORTS.ATTACKERIP" | translate }}</p>
                    </th>
                    <th style="font-size: 16px; padding: 0 10px;">
                      <p class="mb-0 virusName">{{ "PARENTALREPORTS.DESCRIPTION" | translate }}</p>
                    </th>
                    <th style="font-size: 16px; padding: 0 10px;">
                      <p class="mb-0 virusName">{{ "PARENTALREPORTS.ACTIONTAKEN" | translate }}</p>
                    </th>
                  </tr>
                  <tr>
                    <td colspan="6" style="height: 8px; border: none;"></td>
                  </tr>
                </thead>
                <tbody>
                  <tr class="text-capitalize" *ngFor="let i of idsIpsReport">
                    <td style="border-bottom-width: inherit; padding: 0 10px;">
                      <p class="mb-4 virusName">{{ i.date }}</p>
                    </td>
                    <td style="border-bottom-width: inherit; padding: 0 10px;">
                      <p class="mb-4 virusName">{{ i.virusDatabase }}</p>
                    </td>
                    <td style="border-bottom-width: inherit; padding: 0 10px; position: relative;">
                      <div class="custom-tooltip-container-idsips">
                        <p class="mb-4 virusName truncate-idsips" style="margin: 0; cursor: default;"
                          (mouseenter)="i.showTooltip = true" (mouseleave)="i.showTooltip = false">
                          {{ getTruncatedText(i.vulnerabilityDetected, 25) }}
                        </p>

                        <div class="custom-tooltip-idsips" *ngIf="i.showTooltip" [ngStyle]="{
                                    top: i === idsIpsReport[idsIpsReport.length - 1] ? '-50px' : '50px',
                                    bottom: i === idsIpsReport[idsIpsReport.length - 1] ? null : 'auto'
                                  }">
                          <div class="tooltip-container-idsips"
                            [ngClass]="{'last-row-tooltip': i === idsIpsReport[idsIpsReport.length - 1]}">
                            <span class="tooltip-text-idsips">{{ i.vulnerabilityDetected }}</span>
                          </div>
                        </div>
                      </div>
                    </td>

                    <td style="border-bottom-width: inherit; padding: 0 10px;">
                      <p class="mb-4 virusName">{{ i.attackerIp }}</p>
                    </td>
                    <td style="border-bottom-width: inherit; padding: 0 10px;">
                      <p class="mb-4 virusName">{{ i.description }}</p>
                    </td>
                    <td style="border-bottom-width: inherit; padding: 0 10px;">
                      <p class="mb-4 virusName">{{ i.actionTaken | translate }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="mt-3 bg-white p-3" style="border-radius: 12px;"
          *ngIf="idsIpsReport?.length == 0 && selectedSystem?.expirydays > 0">
          <div class="bg-white h-100 p-sm-3 pt-1 me-3">
            <div class="border-bottom negative_padding-threat-table mt-0">
              <div class="  ms-4 text_20_600 mb-4">
                <span style="font-weight: 400;font-size: 18px;"><span>
                    <img class="me-0 mb-1 threat-detect-image" src="./assets/images/threatImage.svg" alt="">
                  </span>
                </span>
                <span class="me-0 threat-detect-insights "> {{
                  "DASHBOARD.IDSIPS" |
                  translate }} </span>

              </div>
            </div>
            <div class="bg-white p-3 mt-3" style="border-radius: 12px;">
              <div class="col-sm-12 text-center">
                <div class="mt-5">
                  <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
                </div>
                <div class="mt-2 mb-5">
                  <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3 bg-white p-3" style="border-radius: 12px;" *ngIf="selectedSystem?.expirydays <= 0">
          <div class="bg-white h-100 p-sm-3 pt-1 me-3">
            <div class="bg-white p-3 mt-3" style="border-radius: 12px;">
              <div class="col-sm-12 text-center">
                <div class="mt-5">
                  <span><img src="./assets/images/license_exp.svg" alt=""></span>
                </div>
                <div class="mt-5 mb-3">
                  <span class="empty-report-text">{{"DASHBOARD.LICENSEEXPIRED" | translate}}</span>
                </div>
                <button
                  [ngClass]="systemList[0]?.productLink == null ? 'q-invalid-button px-4 auto-btn fs-16' : 'submit-btn bg-orgclr auto-btn fs-16' "
                  (click)="openMyIndexRenewLicense(systemList[0])">
                  {{ 'DASHBOARD.RENEWNOW' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<ng-container *ngIf="isListView">
  <div class="col-xl-6">
    <div class="bg-white-blue p-sm-3 p-2 h-100">
      <h4 class="fw-bold textColorGreenVogue mb-0 mt-2" i18n-title>
        {{ "PARENTALREPORTS.WEEKYAPPUSAGE" | translate }}
      </h4>

      <ng-container *ngIf="ScreenMonitoringTable?.length != 0">
        <div class="text-center tbl-div-chng mt-3" id="screentimeTable">
          <table class="table reports-table table-bordered mb-0 h-100" aria-describedby="Web Report Usage">
            <thead>
              <tr style="border-style: hidden" i18n-title>
                <th class=" report-header text-center">
                  {{ "PARENTALREPORTS.DATE" | translate }}
                </th>
                <th class="text-center  report-header">
                  {{ "PARENTALREPORTS.APPWISEGOAL" | translate }}
                </th>
                <th class="report-header w-10rem  text-center">
                  {{ "PARENTALREPORTS.APPNAME" | translate }}
                </th>
                <th class="report-header  text-center">
                  {{
                  "PARENTALREPORTS.APPUTILIZEDTIME" | translate
                  }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-white" *ngFor="let item of ScreenMonitoringTable">
                <td class="vertical-center text-center">
                  {{ item?.date }}
                </td>
                <td class="vertical-center text-center">
                  <ng-container *ngIf="short != 5">
                    <div class="mb-2 text-left" *ngFor="
                                    let i of item?.screenTimeReportList.slice(
                                      0,
                                      3
                                    )
                                  ">
                      {{ i?.allowedTime }}
                    </div>
                  </ng-container>
                </td>
                <td class="vertical-center text-center">
                  <ng-container *ngIf="short != 4">
                    <div class="mb-2 text-left" *ngFor="
                                    let i of item?.screenTimeReportList.slice(
                                      0,
                                      3
                                    )
                                  ">
                      {{ i?.appName }}
                    </div>
                  </ng-container>
                </td>
                <td class="vertical-center text-center">

                  <ng-container *ngIf=" item?.screenTimeReportList?.length <= 3">
                    <div class="mb-2 text-left" *ngFor="
                                    let i of item?.screenTimeReportList.slice(
                                      0,
                                      3
                                    )
                                  ">
                      {{ i?.usedTime }}
                    </div>
                  </ng-container>

                  <ng-container *ngIf=" item?.screenTimeReportList?.length > 3 &&
                                short != 3">
                    <div class="mt-2 text-left" *ngFor="
                                    let i of item?.screenTimeReportList.slice(
                                      0,
                                      3
                                    )
                                  ">
                      {{ i?.usedTime }}
                    </div>
                  </ng-container>




                  <div class="qh-link pt-1" *ngIf="
                                  item?.screenTimeReportList?.length > 3 &&
                                  short != 3
                                " (click)="tableShow('SCREENMONITORING', item)" i18n-title>
                    {{ "PARENTALREPORTS.VIEWMORE" | translate }}
                  </div>






                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
      <ng-container *ngIf="ScreenMonitoringTable?.length === 0">
        <div class="mt-3 p-3 text-center mh-340">
          <div class="col-12">
            <div>
              <img src="assets/images/NoRecordFound.png" class="img-fluid" alt="norecord" height="185px" />
              <h1 class="mt-3">
                <app-main-heading>
                  <span title i18n-title>{{
                    "ACTIVITYHISTORY.NODATAFOUND" | translate
                    }}</span>
                </app-main-heading>
              </h1>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>




<!-- Weekly App Usage Table Modal -->
<div class="modal" id="WeeklyAppSTTablePopup" data-bs-backdrop="static">
  <div class="modal-dialog opt-popup changeWidthHeight relative w-auto pointer-events-none">
    <div
      class="modal-content border-none border-radius-6  changeWidthHeight tablePopUpWidth shadow-lg relative d-flex p-3 p-md-4 flex-column w-100 pointer-events-auto outline-none modal-dialog-centered">
      <!-- Modal Header -->
      <div class="mt-0 mb-3">
        <span style="font-size:26px;font-weight: 600;float: left;"> {{
          "PARENTALREPORTS.WEEKLYAPPUSAGE" |
          translate }} </span>
      </div>
      <div class="table-responsive mb-3" id="deviceTable">
        <table
          class="act-history table activity-table border-radius-6 device-row mb-0 tablePopUpWidth table-fixed scrolldown"
          style="border-spacing: 60px;" aria-describedby="Summary">
          <thead class="activity-header fixedTableHeader border-radius-6" style="font-size: 16px;border-style: hidden;">
            <tr style="border-style: hidden" i18n-title>
              <th style="font-size: 16px; align-content: center;">
                {{ "PARENTALREPORTS.DATE" | translate }}
              </th>
              <th style="font-size: 16px; align-content: center;">
                {{ "PARENTALREPORTS.APP" | translate }}
              </th>
              <th style="font-size: 16px; align-content: center;">
                {{ "DASHBOARD.LIMITSET" | translate }}
              </th>
              <th style="font-size: 16px; align-content: center;">
                {{
                "PARENTALREPORTS.UTILIZEDTIME" | translate
                }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="" *ngFor="let item of ScreenMonitoringTable">
              <td class="align-baseline">{{ item?.date }}</td>
              <td>
                <ng-container>
                  <div class="mb-2" *ngFor="let i of item?.screenTimeReportList">

                    {{ i?.appName }}</div>
                </ng-container>
              </td>
              <td>
                <ng-container>
                  <div class="mb-2" *ngFor="let i of item?.screenTimeReportList">

                    {{ i?.allowedTime }}</div>
                </ng-container>
              </td>
              <td>
                <ng-container>
                  <div class="mb-2" *ngFor="let i of item?.screenTimeReportList"
                    [ngClass]="i?.allowedTime>i?.usedTime?'under-utilized-text':'over-utilized-text'">{{
                    i?.usedTime }}</div>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="position: absolute; top: 25px; right: 25px">
        <span (click)="closeSTTableModal('#WeeklyAppSTTablePopup')"><img src="./assets/images/otpCancel.svg" alt=""
            class="ms-xl-4" /></span>

      </div>
    </div>
  </div>
</div>

<!-- Attempts to access restricted apps Table Modal -->
<div class="modal" id="restAppsTablePopup" data-bs-backdrop="static">
  <div class="modal-dialog opt-popup changeWidthHeight relative w-auto pointer-events-none">
    <div
      class="modal-content border-none border-radius-6  changeWidthHeight tablePopUpWidth shadow-lg relative d-flex p-3 p-md-4 flex-column w-100 pointer-events-auto outline-none modal-dialog-centered">
      <!-- Modal Header -->
      <div class="mt-0 mb-3">
        <span *ngIf="isParentalAppUsageReport" class="table-header-text"> {{
          "PARENTALREPORTS.USAGEREPORTAPP" |
          translate }} </span>
        <span *ngIf="isRestAppReport" class="table-header-text"> {{
          "PARENTALREPORTS.ATTEMPTSTORESTAPP" |
          translate }} </span>
        <span *ngIf="isParentalWebUsageReport" class="table-header-text"> {{
          "PARENTALREPORTS.USAGEREPORTWEB" |
          translate }} </span>
        <span *ngIf="isRestWebReport" class="table-header-text"> {{
          "PARENTALREPORTS.ATTEMPTSTORESTWEB" |
          translate }} </span>
        <span *ngIf="isBlockedVideoReport" class="table-header-text"> {{
          "PARENTALREPORTS.ATTEMPTTOBLOCKEDVIDEOS" |
          translate }} </span>
        <span *ngIf="isBlockedChannelReport" class="table-header-text"> {{
          "PARENTALREPORTS.ATTEMPTTOBLOCKEDCHANNELS" |
          translate }} </span>
        <span *ngIf="isVideoVisitReport" class="table-header-text"> {{
          "PARENTALREPORTS.VIDEOCATVISITS" |
          translate }} </span>
        <span *ngIf="isChannelVisitReport" class="table-header-text"> {{
          "PARENTALREPORTS.CHANNELVISITS" |
          translate }} </span>
      </div>
      <div class="table-responsive mb-3" id="deviceTable">
        <table class="table activity-table border-radius-6 device-row mb-0 tablePopUpWidth table-fixed scrolldown"
          style="border-spacing: 60px;" aria-describedby="Summary">
          <thead class="activity-header fixedTableHeader border-radius-6 border-white">
            <ng-container *ngIf="isParentalAppUsageReport">
              <tr i18n-title>
                <th>
                  {{ "PARENTALREPORTS.APPCATEGORYNAME" | translate }}
                </th>
                <th>
                  {{ "PARENTALREPORTS.TIMESPENT" | translate }}
                </th>
                <th>
                  {{ "PARENTALREPORTS.PERCENTAGE" | translate }}
                </th>
              </tr>
            </ng-container>
            <ng-container *ngIf="isParentalWebUsageReport ">
              <tr i18n-title>
                <th>
                  {{ "PARENTALREPORTS.WEBCATEGORYNAME" | translate }}
                </th>
                <th>
                  {{ "PARENTALREPORTS.VISITCOUNT" | translate }}
                </th>
                <th>
                  {{ "PARENTALREPORTS.PERCENTAGE" | translate }}
                </th>
              </tr>
            </ng-container>
            <ng-container *ngIf="isBlockedVideoReport">
              <tr i18n-title>
                <th>
                  {{ "PARENTALREPORTS.CATEGORY" | translate }}
                </th>
                <th>
                  {{ "PARENTALREPORTS.NOOFVISIT" | translate }}
                </th>
                <th>
                  {{ "PARENTALREPORTS.USAGEPERCENT" | translate }}
                </th>
              </tr>
            </ng-container>
            <ng-container *ngIf="isChannelVisitReport">
              <tr i18n-title>
                <th>
                  {{ "PARENTALREPORTS.CHANNEL" | translate }}
                </th>
                <th>
                  {{ "PARENTALREPORTS.NOOFVISIT" | translate }}
                </th>
              </tr>
            </ng-container>
            <ng-container *ngIf="isRestAppReport || isRestWebReport || isVideoVisitReport">
              <tr i18n-title>
                <th>
                  {{ "PARENTALREPORTS.CATEGORY" | translate }}
                </th>
                <th>
                  {{ "PARENTALREPORTS.NOOFVISIT" | translate }}
                </th>
              </tr>
            </ng-container>
            <ng-container *ngIf="isBlockedChannelReport">
              <tr i18n-title>
                <th>
                  {{ "PARENTALREPORTS.CHANNEL" | translate }}
                </th>
                <th>
                  {{ "PARENTALREPORTS.NOOFVISIT" | translate }}
                </th>
                <th>
                  {{ "PARENTALREPORTS.USAGEPERCENT" | translate }}
                </th>
              </tr>
            </ng-container>
          </thead>
          <ng-container *ngIf="isParentalAppUsageReport">
            <tbody *ngFor="let item of appUsageTableReport">
              <tr>
                <td>{{ item?.category }}</td>
                <td>{{ item?.totalDuration}}</td>
                <td>{{ item?.percentage }}</td>
              </tr>
            </tbody>
          </ng-container>
          <ng-container *ngIf="isParentalWebUsageReport">
            <tbody *ngFor="let item of webUsageTableReport">
              <tr>
              <tr>
                <td>{{ item?.category }}</td>
                <td>{{ item?.hitCount}}</td>
                <td>{{ item?.percentage }}</td>
              </tr>
            </tbody>
          </ng-container>
          <ng-container *ngIf="isRestAppReport">
            <tbody>
              <tr *ngFor="let item of restAppTable">
                <td>{{ item?.category }}</td>
                <td>{{ item?.hitCount }}</td>
              </tr>
            </tbody>
          </ng-container>
          <ng-container *ngIf="isRestWebReport">
            <tbody>
              <tr *ngFor="let item of restWebTable">
                <td>{{ item?.category }}</td>
                <td>{{ item?.hitCount }}</td>
              </tr>
            </tbody>
          </ng-container>
          <ng-container *ngIf="isBlockedVideoReport">
            <tbody>
              <tr *ngFor="let item of blockedVideoTable">
                <td>{{ item.key }}</td>
                <td>{{ item.count }}</td>
                <td>{{ item.usageTime.toFixed(0) }}</td>
              </tr>
            </tbody>
          </ng-container>
          <ng-container *ngIf="isBlockedChannelReport">
            <tbody>
              <tr *ngFor="let item of blockedChannelTableData">
                <td>{{ item.key }}</td>
                <td>{{ item.count }}</td>
                <td>{{ item.usageTime.toFixed(0) }}</td>
              </tr>
            </tbody>
          </ng-container>
          <ng-container *ngIf="isVideoVisitReport">
            <tbody>
              <tr *ngFor="let item of videoCatTableData; index as i">
                <td>{{ item.key }}</td>
                <td>{{ item.count }} </td>
              </tr>
            </tbody>
          </ng-container>
          <ng-container *ngIf="isChannelVisitReport">
            <tbody>
              <tr *ngFor="let item of channelVisitTableData">
                <td>{{ item.key }}</td>
                <td>{{ item.count }} </td>
              </tr>
            </tbody>
          </ng-container>
        </table>
      </div>
      <div style="position: absolute; top: 25px; right: 25px">
        <span (click)="closeSTTableModal('#restAppsTablePopup')"><img src="./assets/images/otpCancel.svg" alt=""
            class="ms-xl-4" /></span>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->

<!-- {{ "MANAGEDEVICE.VERIFYDETAILS" | translate }} popup -->
<div class="modal" id="verifyDetailsPopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" id="forgotpwd">
    <ng-container *ngIf="isMobile">
      <div class="modal-content p-3 forgotpwd rounded-25">
        <!-- Modal Header -->
        <div class="text-center mx-4">
          <h5 class="my-2">
            <app-main-heading>
              <span title i18n-title>
                {{ "MANAGEDEVICE.VERIFYDETAILS" | translate }}</span>
            </app-main-heading>
          </h5>
          <p class="text-xs" i18n-title>
            {{ "MANAGEDEVICE.PLEASEADDMOBILE" | translate }}
          </p>
        </div>
        <!-- Modal body -->
        <form [formGroup]="deviceDetailForm" (ngSubmit)="verifyDeviceDetail()">
          <div class="form-div">
            <div class="form-group mb-3" i18n-title>
              <label for="mblNumoremail" class="mb-1 q-form-label">{{ "MANAGEDEVICE.MOBILENO" | translate }}
                <span class="text-danger">*</span></label>
              <ngx-intl-tel-input [cssClass]="'form-control q-form-control'" [preferredCountries]="[
                    CountryISO.India,
                    CountryISO.UnitedKingdom
                  ]" [enableAutoCountrySelect]="false" [enablePlaceholder]="true"
                customPlaceholder="{{ 'SIGNUP.ENTERYOURMBLNO' | translate }}" [searchCountryFlag]="true"
                [searchCountryField]="[
                    SearchCountryField.Iso2,
                    SearchCountryField.Name
                  ]" [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="15"
                [phoneValidation]="true" name="phone" formControlName="userName">
              </ngx-intl-tel-input>
              <ng-container *ngIf="mobileNoWrong">
                <p class="errMessage">
                  {{ "MANAGEDEVICE.MINANDMAX8" | translate }}
                </p>
              </ng-container>
            </div>

            <div class="mt-3 mb-4" i18n-title>
              <button type="submit" [disabled]="deviceDetailForm.controls['userName'].value?.number?.length<8"
                [ngClass]="
                    deviceDetailForm.controls['userName'].value?.number?.length<8
                      ? 'q-invalid-button mb-3 w-100'
                      : 'submit-btn bg-orgclr mb-3 w-100'
                  ">
                {{ "LOGIN.SUBMIT" | translate }}
              </button>
              <button type="button" class="cancel-btn bg-cancelbtn w-100" (click)="closeModalForMobileNumber()">
                {{ "LOGIN.CANCEL" | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </ng-container>
    <ng-container *ngIf="isOTP">
      <div class="modal-content p-3 enterotp">
        <div class="text-center mt-3" i18n-title>
          <h5 class="mb-0">
            <app-main-heading>
              <span title> {{ "LOGIN.ENTEROTP" | translate }}</span>
            </app-main-heading>
          </h5>
          <small>{{ "LOGIN.SENTON" | translate }} {{ mobileNumber }}</small>
        </div>
        <!-- Modal body -->
        <div class="">
          <div class="mt-4 form-group">
            <div class="d-flex justify-content-center align-items-center mt-1 mb-2">
              <span>
                <div class="charClass me-2 me-md-3">
                  {{ emailResponse }}
                </div>
              </span>
              <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{ length: 4, allowNumbersOnly: true }"
                #ngOtpInput>
              </ng-otp-input>
            </div>
          </div>
          <ng-container *ngIf="otpError">
            <p class="errMessage" style="margin: 10px 90px">{{ otpError }}</p>
          </ng-container>
          <div class="mt-4 mb-3 form-div" i18n-title>
            <button type="button" class="submit-btn bg-orgclr w-100 mb-3" (click)="submitOTP()">
              {{ "LOGIN.SUBMIT" | translate }}
            </button>
            <button type="button" class="cancel-btn bg-cancelbtn w-100" (click)="closeModalForMobileNumber()">
              {{ "LOGIN.CANCEL" | translate }}
            </button>
          </div>

          <ng-container *ngIf="isOTP && timeOver">
            <div class="d-flex align-items-center justify-content-center mb-3" i18n-title>
              <small>
                {{ "RESENDOT.RESENDOTPIN" | translate }}
                {{ durationMinutes }}</small>
            </div>
          </ng-container>
          <div class="d-flex mt-2 align-items-center justify-content-center notOtpDiv mb-3" *ngIf="!timeOver && isOTP"
            i18n-title>
            <span>{{ "LOGIN.DIDNTRECEIVEOTP" | translate }}</span>
            <button type="button" class="border-0 bg-white resend-Otp cursor-pointer shadow-none outline-none p-0 ms-2"
              (click)="resendOtp()">
              {{ "LOGIN.RESEND" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isDone">
      <div
        class="modal-content rounded-25 border-none shadow-lg relative d-flex flex-column w-100 pointer-events-auto bg-white outline-none">
        <div class="modal-body relative pt-3">
          <div class="text-center mt-3">
            <div>
              <img src="./assets/images/SuccessIllustration.png" alt="" class="mx-auto" />
            </div>
            <h5 class="fw-bold mt-3 mb-3" i18n-title>
              {{ "SUCESSMESSAGE.PHONEVERIFIED" | translate }}
            </h5>
            <button class="submit-btn bg-orgclr w-auto" (click)="closeVerifyDetails()" i18n-title>
              {{ "SIGNUP.DONE" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div class="modal" id="renewPopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered ">
    <ng-container>
      <div
        class="modal-content text-center border-none changeWidthHeight rounded-25 shadow-lg relative w-100 pointer-events-auto bg-white outline-none">
        <div class="mt-3">
          <img src="./assets/images/not secure.png" alt="" class="mx-auto" />
        </div>
        <h5 class="fw-bold mt-1 mb-2">
          {{ "LICENSESUMMARY.RENEWPOPUP" | translate }}
        </h5>
        <p class="text-sm p-xl-2">
          {{ "LICENSESUMMARY.RENEWDESC" | translate }}

        </p>

        <div class="text-center mb-4 mt-1 d-flex justify-content-center">
          <div class="me-3">
            <button type="button" class="submit-btn bg-orgclr" data-bs-dismiss="modal">
              {{ "LICENSESUMMARY.OK" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!--  Table Modal -->

<div class="modal" id="tableDetails" data-bs-backdrop="static">

  <div class="modal-dialog modal-dialog-centered" id="tabledetail">
    <div class="modal-content-table p-3 forgotpwd rounded-25">
      <!-- Modal Header -->

      <div>
        <div class="border-bottom py-2 w-100">
          <h5 class="mb-0" *ngIf="isChannelCategoryReport">
            <app-main-heading>
              <span title i18n-title>
                {{ "PARENTALREPORTS.CHANNELCATEGORY" | translate }}</span>
            </app-main-heading>
          </h5>
          <h5 class="mb-0" *ngIf="isParentalWebUsageReport">
            <app-main-heading>
              <span title i18n-title>
                {{ "PARENTALREPORTS.WEBUSESREPORT" | translate }}</span>
            </app-main-heading>
          </h5>
          <h5 class="mb-0" *ngIf="isYoutubeChannelReport">
            <app-main-heading>
              <span title i18n-title>
                {{ "PARENTALREPORTS.CHANNELREPORT" | translate }}</span>
            </app-main-heading>
          </h5>
          <h5 class="mb-0" *ngIf="isYoutubeVideoReport">
            <app-main-heading>
              <span title i18n-title>
                {{ "PARENTALREPORTS.VIDEOREPORT" | translate }}</span>
            </app-main-heading>
          </h5>
          <h5 class="mb-0" *ngIf="isThreatReportTable">
            <app-main-heading>
              <span title i18n-title>
                {{ "PARENTALREPORTS.THREATREPORT" | translate }}</span>
            </app-main-heading>
          </h5>
          <h5 class="mb-0" *ngIf="isParentalAppUsageReport">
            <app-main-heading>
              <span title i18n-title>
                {{ "PARENTALREPORTS.APPUSESREPORT" | translate }}</span>
            </app-main-heading>
          </h5>
          <h5 class="mb-0" *ngIf="isFirewallReportTable">
            <app-main-heading>
              <span title i18n-title>
                {{ "PARENTALREPORTS.FIREWALLREPORT" | translate }}</span>
            </app-main-heading>
          </h5>
        </div>
        <ng-container *ngIf="isChannelCategoryReport">
          <div class="pt-2 q-form-label " *ngFor="let i of viewmoreArray">{{i.date}}</div>
        </ng-container>
        <ng-container *ngIf="isParentalWebUsageReport">
          <div class="pt-2 q-form-label " *ngFor="let i of viewmoreArray">{{i.date}}</div>
        </ng-container>
        <ng-container *ngIf="isYoutubeChannelReport">
          <div class="pt-2 q-form-label " *ngFor="let i of viewmoreArray">{{i.date}}</div>
        </ng-container>
        <ng-container *ngIf="isYoutubeVideoReport">
          <div class="pt-2 q-form-label " *ngFor="let i of viewmoreArray">{{i.date}}</div>
        </ng-container>
        <ng-container *ngIf="isThreatReportTable">
          <div class="pt-2 q-form-label " *ngFor="let i of viewmoreArray">{{i.date}}</div>
        </ng-container>
        <ng-container *ngIf="isParentalAppUsageReport">
          <div class="pt-2 q-form-label " *ngFor="let i of viewmoreArray">{{i.appUsageDate}}</div>
        </ng-container>
        <ng-container *ngIf="isFirewallReportTable">
          <div class="pt-2 q-form-label " *ngFor="let i of viewmoreArray">{{i.dateTime}}</div>
        </ng-container>
      </div>

      <!-- Modal body -->
      <div class="mb-4 mt-2 d-flex justify-content-between">
        <div class="relative">
          <div class="d-flex align-items-center border rounded" i18n-title>
            <img [src]="'HELPFAQ.SEARCHICONiMG' | translate" alt="" class="px-1" />
            <input type="text" class="form-control searchBarInput border-0"
              placeholder="{{ 'HELPFAQ.SEARCHHERE' | translate }}" [(ngModel)]="searchText" />
          </div>
        </div>
      </div>
      <ng-container *ngIf="isChannelCategoryReport">
        <div class="tbl-div-chng-modal">

          <!-- table template 2 -->

          <table class="table report-table table-bordered mb-0 h-100" aria-describedby="Web Report Usage"
            *ngIf="isChannelCategoryReport">
            <thead>
              <tr style="border-style: hidden" i18n-title>
                <th class="text-center w-10rem report-header">
                  {{ "PARENTALREPORTS.APPWISEGOAL" | translate }}
                </th>
                <th class="report-header  text-center text-wrap">
                  {{ "PARENTALREPORTS.APPNAME" | translate }}
                </th>
                <th class="report-header w-10rem text-center">
                  {{ "PARENTALREPORTS.APPUTILIZEDTIME" | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-white" *ngFor="let item of viewmoreArray[0]['screenTimeReportList']| filter : searchText | paginate
              : {
                  id: 'channelCategoryReport',
                  itemsPerPage: 10,
                  currentPage: p
                }">
                <td class=" text-center vertical-center ">
                  {{ item?.allowedTime }}
                </td>
                <td class=" text-center vertical-center text-break">
                  {{ item?.appName }}
                </td>
                <td class="text-center vertical-center">
                  {{ item?.usedTime }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-end my-2 report-popup-text" *ngIf="isChannelCategoryReport">
          <pagination-controls (pageChange)="p = $event" id="channelCategoryReport"></pagination-controls>
        </div>
      </ng-container>
      <!-- parental web usage report -->
      <ng-container *ngIf="isParentalWebUsageReport">
        <div class="tbl-div-chng-modal">

          <!-- table template - 1 -->
          <!-- table template - 2 -->

          <table class="table reports-table table-bordered mb-0 h-100" aria-describedby="Web Report Usage"
            *ngIf="isParentalWebUsageReport">
            <thead>
              <tr style="border-style: hidden" i18n-title>
                <th class="text-center w-10rem report-header">
                  {{ "PARENTALREPORTS.NOOFVISIT" | translate }}
                </th>
                <th class="report-header   text-center text-wrap">
                  {{ "PARENTALREPORTS.WEBSITE" | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-white" *ngFor="
                  let webUsesReport of viewmoreArray[0]['websiteDtoList'] | filter : searchText | paginate
                  : {
                      id: 'parentalWebUsageReport',
                      itemsPerPage: 10,
                      currentPage: p
                    }
                ">
                <td class="vertical-center text-center">
                  {{ webUsesReport?.visitedCount }}
                </td>
                <td class="vertical-center text-break">
                  <img class="mx-1" src="/assets/images/blockweb.svg" alt="" *ngIf="webUsesReport.isBlock == true" />
                  <span>{{ webUsesReport?.website }}</span>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
        <div class="d-flex justify-content-end my-2 report-popup-text" *ngIf="isParentalWebUsageReport">
          <pagination-controls (pageChange)="p = $event" id="parentalWebUsageReport"></pagination-controls>
        </div>
      </ng-container>
      <!-- youtube video report -->
      <ng-container *ngIf="isYoutubeChannelReport">
        <div class="tbl-div-chng-modal">

          <!-- table template - 1 -->

          <!-- table template - 2 -->

          <table class="table reports-table table-bordered mb-0 h-100" aria-describedby="Web Report Usage"
            *ngIf="isYoutubeChannelReport">
            <thead>
              <tr style="border-style: hidden" i18n-title>
                <th class="w-10rem text-center report-header">
                  {{ "PARENTALREPORTS.NUMBEROFVISIT" | translate }}
                </th>
                <th class="text-center report-header">
                  {{ "PARENTALREPORTS.CHANNELNAME" | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-white" *ngFor="let i of viewmoreArray[0]['channelReportList'] | filter : searchText | paginate
              : {
                  id: 'youtubeChannelReport',
                  itemsPerPage: 10,
                  currentPage: p
                }">
                <td class=" text-center vertical-center">
                  {{ i?.count }}

                </td>
                <td class=" text-center vertical-center text-break">
                  <img class="mx-1" src="/assets/images/blockweb.svg" alt="" *ngIf="i.isBlock == true" />
                  {{ i?.key }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-end my-2 report-popup-text" *ngIf="isYoutubeChannelReport">
          <pagination-controls (pageChange)="p = $event" id="youtubeChannelReport"></pagination-controls>
        </div>
      </ng-container>
      <!-- youtube channel report -->
      <ng-container *ngIf="isYoutubeVideoReport">
        <div class="tbl-div-chng-modal">

          <!--table template - 1  -->

          <!-- table template - 2 -->

          <table class="table reports-table table-bordered mb-0 h-100" aria-describedby="Web Report Usage"
            *ngIf="isYoutubeVideoReport">
            <thead>
              <tr style="border-style: hidden" i18n-title>
                <th class="w-10rem text-center  report-header ">
                  {{ "PARENTALREPORTS.NUMBEROFVISIT" | translate }}
                </th>
                <th class="text-center report-header text-wrap">
                  {{ "PARENTALREPORTS.WEBSITE" | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-white" *ngFor="let i of viewmoreArray[0]['videoReportList'] | filter : searchText   | paginate
              : {
                  id: 'youtubeVideoReport',
                  itemsPerPage: 10,
                  currentPage: p
                }">
                <td class="vertical-center text-center">
                  {{ i?.count }}
                </td>
                <td class="vertical-center text-break">
                  <img class="mx-1" src="/assets/images/blockweb.svg" alt="" *ngIf="i.isBlock == true" />
                  <span (click)="goToYoutubeVideo(i)" class=" hoverHyperLink cursor-pointer">{{
                    i?.videoName==''|| i?.videoName==null ?
                    i?.key:i?.videoName }}</span>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
        <div class="d-flex justify-content-end my-2 report-popup-text" *ngIf="isYoutubeVideoReport">
          <pagination-controls (pageChange)="p = $event" id="youtubeVideoReport"></pagination-controls>
        </div>
      </ng-container>
      <!-- threat report table -->
      <ng-container *ngIf="isThreatReportTable">
        <div class="tbl-div-chng-modal">

          <!-- table template - 1  -->

          <!-- table template - 2 -->

          <table class="table report-table table-bordered mb-0 h-100" aria-describedby="Web Report Usage"
            *ngIf="isThreatReportTable">
            <thead>
              <tr style="border-style: hidden" i18n-title>
                <th class="report-header text-center w-10rem" *ngIf="this.deviceType == 'SYSTEM'">
                  {{ "PARENTALREPORTS.VIRUSTYPE" | translate }}
                </th>

                <th class="report-header text-center  text-wrap">
                  <span *ngIf="this.deviceType == 'MOBILE'">
                    {{ "PARENTALREPORTS.VIRUSDETAILS" | translate }}
                  </span>

                  <span *ngIf="this.deviceType == 'SYSTEM'">
                    {{ "PARENTALREPORTS.THREATDETAILS" | translate }}
                  </span>
                </th>

                <th class="report-header text-center  text-wrap" *ngIf="this.deviceType == 'MOBILE'">
                  {{ "PARENTALREPORTS.VIRUSTYPE" | translate }}
                </th>

                <th class="report-header text-center w-10rem">
                  {{ "PARENTALREPORTS.STATUS" | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-white" *ngFor="let i of viewmoreArray[0]['threatReportList'] | filter : searchText | paginate
              : {
                  id: 'threatReportTable',
                  itemsPerPage: 10,
                  currentPage: p
                }">
                <td class=" text-center" *ngIf="this.deviceType == 'SYSTEM'">
                  <div class="py-3 popstatus-text">
                    {{ i?.key }}
                  </div>
                </td>
                <td class="vertical-center text-break ">
                  <img src="../../../assets/images/File.svg" class="me-2" width="19"
                    *ngIf="i.threatType==0 && this.deviceType == 'MOBILE'" alt="">
                  <img src="../../../assets/images/Android_robot.svg" class="me-2" width="17"
                    *ngIf="i.threatType==1 && this.deviceType == 'MOBILE'" alt="">
                  {{this.deviceType == 'MOBILE'? i.key:i.location }}
                </td>
                <td class="vertical-center text-center " *ngIf="this.deviceType == 'MOBILE'">
                  {{ i?.virusType | titlecase }}
                </td>

                <td class="vertical-center text-center ">
                  {{ i?.status | titlecase }}
                </td>
              </tr>
            </tbody>
          </table>

        </div>
        <div class="d-flex justify-content-end my-2 report-popup-text" *ngIf="isThreatReportTable">
          <pagination-controls (pageChange)="p = $event" id="threatReportTable"></pagination-controls>
        </div>
      </ng-container>

      <ng-container *ngIf="isFirewallReportTable">
        <div class="tbl-div-chng-modal">
          <table class="table report-table table-bordered mb-0 h-100" aria-describedby="Web Report Usage"
            *ngIf="isFirewallReportTable">
            <thead>
              <tr style="border-style: hidden" i18n-title>

                <th class="report-header text-center w-10rem">
                  {{ "PARENTALREPORTS.DATE" | translate }}
                </th>

                <th class="report-header text-center w-10rem">
                  {{ "PARENTALREPORTS.VDBDATE" | translate }}
                </th>

                <th class="report-header text-center  text-wrap">
                  {{ "PARENTALREPORTS.APPLICATION" | translate }}
                </th>

                <th class="report-header text-center w-10rem">
                  {{ "PARENTALREPORTS.FILEPATH" | translate }}
                </th>

                <th class="report-header text-center text-wrap">
                  {{ "PARENTALREPORTS.ACTIONTAKEN" | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-white" *ngFor="let i of viewmoreArray[0]['firewallReportList'] | filter : searchText | paginate
              : {
                  id: 'firewallReportTable',
                  itemsPerPage: 10,
                  currentPage: p
                }">

                <td class=" text-center">
                  <div class="py-3 popstatus-text">
                    {{ i?.dateTime }}
                  </div>
                </td>
                <td class=" text-center">
                  <div class="py-3 popstatus-text">
                    {{ i?.vdbDate }}
                  </div>
                </td>

                <td class="vertical-center text-center ">
                  {{ i?.programName | titlecase }}
                </td>

                <td class="vertical-center text-center ">
                  {{ i?.programPath | titlecase }}
                </td>

                <td class=" text-center">
                  {{ i?.actionTaken | translate }}
                </td>
              </tr>
            </tbody>
          </table>

        </div>
        <div class="d-flex justify-content-end my-2 report-popup-text" *ngIf="isFirewallReportTable">
          <pagination-controls (pageChange)="p = $event" id="firewallReportTable"></pagination-controls>
        </div>
      </ng-container>


      <!-- Appuses Report table -->
      <ng-container *ngIf="isParentalAppUsageReport">
        <div class="tbl-div-chng-modal">

          <!-- table template - 1 -->

          <!-- table template - 2 -->

          <table class="table reports-table table-bordered mb-0 h-100" aria-describedby="APPUSESREPORT Usage"
            *ngIf="isParentalAppUsageReport">
            <thead>
              <tr style="border-style: hidden" i18n-title>
                <th class="text-center report-header w-10rem">
                  {{ "PARENTALREPORTS.TOTALDURATION" | translate }}
                </th>
                <th class="report-header text-center">
                  {{ "PARENTALREPORTS.APPLICATION" | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-white" *ngFor="
                  let appUsesReport of viewmoreArray[0]['websiteList'] | filter : searchText  | paginate
                  : {
                      id: 'parentalAppUsageReport',
                      itemsPerPage: 10,
                      currentPage: p
                    }
                ">
                <td class="vertical-center text-center">
                  {{ appUsesReport?.totalDuration }}
                </td>
                <td class="vertical-center text-center">
                  <img class="mx-1" src="../../../assets/images/blockweb.svg" alt=""
                    *ngIf="appUsesReport.isBlock == true" />
                  {{ appUsesReport?.website }}
                </td>
              </tr>
            </tbody>
          </table>

        </div>
        <div class="d-flex justify-content-end my-2 report-popup-text" *ngIf="isParentalAppUsageReport">
          <pagination-controls (pageChange)="p = $event" id="parentalAppUsageReport"></pagination-controls>
        </div>
      </ng-container>
      <div class="me-3 d-flex justify-content-center" id="popupClose">
        <button type="button" class="cancel-btn bg-cancelbtn report-popup-text" (click)="closeTable()" i18n-title>
          {{ "PARENTALREPORTS.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>